{
  "reference": [
    {
      "candidateKey": "former-mortuary-guard-ossa-dareth",
      "templateId": "former-mortuary-guard",
      "templateTitle": "The Former Mortuary Guard",
      "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
      "culture": "Veyrathi",
      "name": "Ossa Dareth",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:oil-flask"
      ],
      "person": {
        "id": "person:companion-former-mortuary-guard-ossa-dareth",
        "lineageKey": "lineage:former-mortuary-guard-ossa-dareth",
        "presentationKey": "presentation:actor-mortuary-guard-rotation",
        "kinshipKeys": [
          "kinship:former-mortuary-guard-ossa-dareth-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Ossa Dareth",
          "origin": "disgraced-legionary",
          "culture": "Veyrathi",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "funerary-vigil",
            "spear-drill"
          ],
          "abilities": [
            "thrust",
            "set-spear"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 9,
          "maxHp": 9,
          "allegiances": [],
          "oaths": [
            "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Veyrathi customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-former-mortuary-guard-ossa-dareth",
        "temperament": {
          "boldness": 1,
          "loyalty": 9
        },
        "obligations": [
          {
            "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-ossa-dareth",
            "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "That was a person. I will not put iron into someone who cannot refuse it. Find another way past."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:former-mortuary-guard-refuse-unlawful-desecration-former-mortuary-guard-ossa-dareth",
            "kind": "non-negotiable-topic",
            "topic": "withdraw"
          }
        ],
        "preferences": {
          "engage": 0,
          "guard": 8,
          "hold": 8,
          "withdraw": 9
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
        "personId": "person:companion-former-mortuary-guard-ossa-dareth",
        "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
        "prerequisites": {
          "all": [
            "hired:former-mortuary-guard-ossa-dareth"
          ],
          "any": [],
          "none": [
            "departed:former-mortuary-guard-ossa-dareth"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
          "status": "achieved",
          "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
          "effects": {
            "add": [
              "obligation-resolved:former-mortuary-guard-ossa-dareth",
              "loyalty-proven:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
          "status": "compromised",
          "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
          "effects": {
            "add": [
              "obligation-compromised:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-ossa-dareth",
          "status": "abandoned",
          "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
          "effects": {
            "add": [
              "departed:former-mortuary-guard-ossa-dareth"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-ossa-dareth"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "ask",
            "label": "Speak with Ossa Dareth (The Former Mortuary Guard)"
          },
          "text": "I kept the night watch at the mortuary gate for six years and said the names over every cart. Then the coffins started going in light. I have not stopped saying the names.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-ossa-dareth",
              "rejected:former-mortuary-guard-ossa-dareth",
              "dead:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "met:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "offer",
            "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
          },
          "text": "Twelve cuts, and a promise. The dead are not freight. Remember that, and my spear is yours to the kilns and back.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Ossa Dareth.",
          "prerequisites": {
            "all": [
              "met:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-ossa-dareth",
              "dead:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "hired:former-mortuary-guard-ossa-dareth",
              "companion-active:former-mortuary-guard-ossa-dareth"
            ],
            "remove": [
              "available:former-mortuary-guard-ossa-dareth"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "covenant:no-desecration"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No. Not in a burial place. I do not hunt men across graves.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-ossa-dareth",
              "departed:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I will stand at your shoulder, as I stood at the gate. Nothing passes.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-ossa-dareth",
              "departed:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Agreed. We cannot carry anyone if we are carried ourselves.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-ossa-dareth",
              "departed:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "You have the grooves copied. If the anchor can be undone without breaking him, do it now. His family should not wait for a vote.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:former-mortuary-guard-ossa-dareth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-former-mortuary-guard-ossa-dareth",
          "intention": {
            "kind": "leave",
            "label": "Ossa Dareth departs over contract violation"
          },
          "text": "You bought them more wax. I will guard a body. I will not guard your right to use one. We are done.",
          "disclosure": "essential",
          "firstEncounterSummary": "Ossa Dareth leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-ossa-dareth",
              "boundary-breached:former-mortuary-guard-ossa-dareth"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-ossa-dareth",
              "departed:former-mortuary-guard-ossa-dareth"
            ]
          },
          "effects": {
            "add": [
              "departed:former-mortuary-guard-ossa-dareth"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-ossa-dareth"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-former-mortuary-guard-ossa-dareth",
        "name": "Ossa Dareth",
        "templateId": "former-mortuary-guard",
        "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
        "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
        "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
      },
      "absenceResponse": {
        "companionId": "person:companion-former-mortuary-guard-ossa-dareth",
        "name": "Ossa Dareth",
        "templateId": "former-mortuary-guard",
        "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
        "departureLine": "You bought them more wax. I will guard a body. I will not guard your right to use one. We are done.",
        "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
      },
      "voice": {
        "voiceId": "guard-vigil",
        "care": {
          "offered": "A {item} for the living. Thank you. We must remember them as well.",
          "treat": "The watch can wait a moment. I mean to keep it longer.",
          "remember": "{giver} gave me supplies from their own keeping. I speak of that when I say their name.",
          "aid": "The fighting is ended. Sit with me; this wound still needs tending.",
          "rememberAid": "I tended {patient} while I still could. I remember the living as well as the names of the dead."
        },
        "manner": "Solemn and liturgical; slow; speaks of the watch and the names; cautious, very loyal.",
        "temperament": {
          "boldness": 1,
          "loyalty": 9
        },
        "obligation": "Stood six years at the mortuary gate. Will see the stolen dead named and carried home.",
        "opening": "I kept the night watch at the mortuary gate for six years and said the names over every cart. Then the coffins started going in light. I have not stopped saying the names.",
        "hire": "Twelve cuts, and a promise. The dead are not freight. Remember that, and my spear is yours to the kilns and back.",
        "hired": "I walk with you, and I keep saying the names. Tell me when we are near the dead.",
        "refusal": "That was a person. I will not put iron into someone who cannot refuse it. Find another way past.",
        "afterFight": {
          "guard": "Close his eyes. Whatever he guarded, he was a man, and he gets the same rite as the rest. Then we go on.",
          "tunnel": "Rest. There is nothing left to stoke. I will say the name when we learn it."
        },
        "moment": {
          "request": "You have the grooves copied. If the anchor can be undone without breaking him, do it now. His family should not wait for a vote.",
          "kept": "He can be carried. That is all the rite asks. The rest is only words, and I have plenty.",
          "broken": "You bought them more wax. I will guard a body. I will not guard your right to use one. We are done."
        },
        "judgment": {
          "good": "Nine names read, nine bodies to carry. It is not a victory. It is the watch, done properly, for once.",
          "bad": "You let the fire take them, or you let the work go on. Either way, they cannot be named. I will say the rite without you.",
          "depart": "Go if you must. I stay with the dead until they are carried. That was always the watch.",
          "mourning": "I will stand the night watch over you, as I did the others. Your name goes on the list with theirs, spoken, not written."
        },
        "discuss": {
          "guard": {
            "accepted": "I will stand at your shoulder, as I stood at the gate. Nothing passes.",
            "refused": "My place is between the living and the dead. Today that is not beside you."
          },
          "engage": {
            "accepted": "If it is a living guard and he gives way, I will close the distance.",
            "refused": "No. Not in a burial place. I do not hunt men across graves."
          },
          "withdraw": {
            "accepted": "Agreed. We cannot carry anyone if we are carried ourselves.",
            "refused": "I do not leave the dead unwatched. Ask anything else of me."
          }
        },
        "barks": {
          "engage": "In the name of the watch.",
          "guard": "At your shoulder. Nothing passes.",
          "hold": "We hold, as the dead hold.",
          "withdraw": "Step back. The watch goes on.",
          "defend": "My watch is not ended. I will meet that blow."
        },
        "returning": {
          "kept": "I stood watch with the outsider before you. They carried the names home and lived to tell it. I say their name too, among the living.",
          "mourned": "I kept the night watch over the last outsider who hired me. Their name is on my list now. Tell me yours, so I know it when I need it.",
          "absent": "Keeping a vigil at the kiln gate and will not leave it. Told the porters no outsider is owed a spear again."
        }
      }
    },
    {
      "candidateKey": "displaced-mason-eshra-ul-anar",
      "templateId": "displaced-mason",
      "templateTitle": "The Displaced Mason",
      "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
      "culture": "Serekh",
      "name": "Eshra ul-Anar",
      "equipment": [
        "item:blade-iron",
        "item:knife-belt",
        "item:gambeson",
        "item:hook-sluicekeeper"
      ],
      "person": {
        "id": "person:companion-displaced-mason-eshra-ul-anar",
        "lineageKey": "lineage:displaced-mason-eshra-ul-anar",
        "presentationKey": "presentation:actor-outsider-axe-rotation",
        "kinshipKeys": [
          "kinship:displaced-mason-eshra-ul-anar-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Eshra ul-Anar",
          "origin": "escaped-worker",
          "culture": "Serekh",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "quarry-masonry",
            "structural-knowledge"
          ],
          "abilities": [
            "pry-pawl",
            "cleave"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Serekh customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-displaced-mason-eshra-ul-anar",
        "temperament": {
          "boldness": 5,
          "loyalty": 2
        },
        "obligations": [
          {
            "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-eshra-ul-anar",
            "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "He is on Noll’s wage, same as I was on the quarry’s. I will not kill a worker over a quarrel between his betters."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:displaced-mason-refuse-reckless-charge-displaced-mason-eshra-ul-anar",
            "kind": "refuse-goal",
            "goal": "engage"
          }
        ],
        "preferences": {
          "engage": 6,
          "guard": 1,
          "hold": 6,
          "withdraw": 6
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
        "personId": "person:companion-displaced-mason-eshra-ul-anar",
        "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
        "prerequisites": {
          "all": [
            "hired:displaced-mason-eshra-ul-anar"
          ],
          "any": [],
          "none": [
            "departed:displaced-mason-eshra-ul-anar"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
          "status": "achieved",
          "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
          "effects": {
            "add": [
              "obligation-resolved:displaced-mason-eshra-ul-anar",
              "loyalty-proven:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
          "status": "compromised",
          "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
          "effects": {
            "add": [
              "obligation-compromised:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:displaced-mason-displaced-mason-eshra-ul-anar",
          "status": "abandoned",
          "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
          "effects": {
            "add": [
              "departed:displaced-mason-eshra-ul-anar"
            ],
            "remove": [
              "companion-active:displaced-mason-eshra-ul-anar"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "ask",
            "label": "Speak with Eshra ul-Anar (The Displaced Mason)"
          },
          "text": "Our crew built half this stair. The quarry killed six of us with a cheap prop and paid the widows in apologies. Ask me what the concession costs, and I will tell you who paid for it.",
          "disclosure": "essential",
          "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:displaced-mason-eshra-ul-anar",
              "rejected:displaced-mason-eshra-ul-anar",
              "dead:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "met:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "offer",
            "label": "Guarantee twelve cuts and swear not to harm civil works"
          },
          "text": "Twelve cuts to the widows’ box, witnessed. I work for you, not for Noll, not for the Senate. The minute that changes, so do I.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Eshra ul-Anar.",
          "prerequisites": {
            "all": [
              "met:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "hired:displaced-mason-eshra-ul-anar",
              "dead:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "hired:displaced-mason-eshra-ul-anar",
              "companion-active:displaced-mason-eshra-ul-anar"
            ],
            "remove": [
              "available:displaced-mason-eshra-ul-anar"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "guarantee:civil-infrastructure"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No. He is paid to stand there, same as me. I do not chase working men.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-eshra-ul-anar",
              "departed:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I look after myself first. The crew taught me that too, the hard way.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-eshra-ul-anar",
              "departed:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Good. No crew ever got a medal for staying under a falling roof.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-eshra-ul-anar",
              "departed:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "That walkway is a public work. Two cuts of timber keeps it. Lift the pawl for a toll box and you are doing the concession’s job for them.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:displaced-mason-eshra-ul-anar"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-displaced-mason-eshra-ul-anar",
          "intention": {
            "kind": "leave",
            "label": "Eshra ul-Anar departs over contract violation"
          },
          "text": "You flooded a public way for a tin box of cuts. That is the quarry’s arithmetic. Find another back.",
          "disclosure": "essential",
          "firstEncounterSummary": "Eshra ul-Anar leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-eshra-ul-anar",
              "boundary-breached:displaced-mason-eshra-ul-anar"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-eshra-ul-anar",
              "departed:displaced-mason-eshra-ul-anar"
            ]
          },
          "effects": {
            "add": [
              "departed:displaced-mason-eshra-ul-anar"
            ],
            "remove": [
              "companion-active:displaced-mason-eshra-ul-anar"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-displaced-mason-eshra-ul-anar",
        "name": "Eshra ul-Anar",
        "templateId": "displaced-mason",
        "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
        "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
        "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
      },
      "absenceResponse": {
        "companionId": "person:companion-displaced-mason-eshra-ul-anar",
        "name": "Eshra ul-Anar",
        "templateId": "displaced-mason",
        "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
        "departureLine": "You flooded a public way for a tin box of cuts. That is the quarry’s arithmetic. Find another back.",
        "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
      },
      "voice": {
        "voiceId": "mason-crew",
        "care": {
          "offered": "I will take the {item}. The contract never said we had to bleed for free.",
          "treat": "Cover the gap. I am keeping a worker alive.",
          "remember": "{giver} shared the medicine. Owners usually call our wounds a cost of doing business.",
          "aid": "Enough work for now. Sit down. The medicine is mine, and I say you need it.",
          "rememberAid": "I used my supplies on {patient}. Looking after each other was never a wage deduction."
        },
        "manner": "Sharp and political; speaks for 'the crew'; sardonic about owners; independent.",
        "temperament": {
          "boldness": 5,
          "loyalty": 2
        },
        "obligation": "Wages go to the widows of a crew the quarry buried. No breaking what workers built.",
        "opening": "Our crew built half this stair. The quarry killed six of us with a cheap prop and paid the widows in apologies. Ask me what the concession costs, and I will tell you who paid for it.",
        "hire": "Twelve cuts to the widows’ box, witnessed. I work for you, not for Noll, not for the Senate. The minute that changes, so do I.",
        "hired": "The crew’s money is in escrow and I am on your side of it. Ask me who built what we pass. I usually know.",
        "refusal": "He is on Noll’s wage, same as I was on the quarry’s. I will not kill a worker over a quarrel between his betters.",
        "afterFight": {
          "guard": "Paid by Noll, killed by you, buried by nobody. They will enter him as a loss against the concession and call it accounts.",
          "tunnel": "That was a worker before it was a stoker. Still on shift. Nobody ever lets us stop."
        },
        "moment": {
          "request": "That walkway is a public work. Two cuts of timber keeps it. Lift the pawl for a toll box and you are doing the concession’s job for them.",
          "kept": "Two cuts for timber. The walkway belongs to whoever crosses it. That is how it should be.",
          "broken": "You flooded a public way for a tin box of cuts. That is the quarry’s arithmetic. Find another back."
        },
        "judgment": {
          "good": "Wages paid, work standing, nobody owned at the end of it. Write that down; it does not happen often.",
          "bad": "You sided with the owners when it mattered. I have buried men for less. I am done here.",
          "depart": "Walking out before the account closes. Owners do that. I will stay and see it paid.",
          "mourning": "Another name for the wall. The widows’ box gets its twelve cuts. I will say you paid them fairly."
        },
        "discuss": {
          "guard": {
            "accepted": "Fine. We look after each other. That is the only rule the crew ever had.",
            "refused": "I look after myself first. The crew taught me that too, the hard way."
          },
          "engage": {
            "accepted": "If it is him or us, I pick us.",
            "refused": "No. He is paid to stand there, same as me. I do not chase working men."
          },
          "withdraw": {
            "accepted": "Good. No crew ever got a medal for staying under a falling roof.",
            "refused": "I will leave when I choose. I did not sell you my judgement."
          }
        },
        "barks": {
          "engage": "Him or us. Us.",
          "guard": "Close up. Crew rules.",
          "hold": "Stand. Make him come.",
          "withdraw": "Not dying for Noll’s floor.",
          "defend": "I have carried worse than your blade. Come on."
        },
        "returning": {
          "kept": "I worked for the last outsider. Paid fair, left the walkway standing, got out alive. That makes one. Let us see if you make two.",
          "mourned": "The last outsider who hired me is on the wall now, beside my crew. They paid fair. It did not save them.",
          "absent": "Took the widows’ box back to the quarry and stayed there. Said outsiders spend public works like pocket money."
        }
      }
    },
    {
      "candidateKey": "unpaid-shield-erenna-veld",
      "templateId": "unpaid-shield",
      "templateTitle": "The Unpaid Shield",
      "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
      "culture": "Veyrathi",
      "name": "Erenna Veld",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:knife-belt"
      ],
      "person": {
        "id": "person:companion-unpaid-shield-erenna-veld",
        "lineageKey": "lineage:unpaid-shield-erenna-veld",
        "presentationKey": "presentation:actor-unpaid-shield-rotation",
        "kinshipKeys": [
          "kinship:unpaid-shield-erenna-veld-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Erenna Veld",
          "origin": "disgraced-legionary",
          "culture": "Veyrathi",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "shield-discipline",
            "spear-drill"
          ],
          "abilities": [
            "brace-drill"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Veyrathi customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-unpaid-shield-erenna-veld",
        "temperament": {
          "boldness": 7,
          "loyalty": 3
        },
        "obligations": [
          {
            "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-erenna-veld",
            "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "Charge on your own coin. Nobody pays me enough for that."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-erenna-veld",
            "kind": "danger-limit",
            "dangerLimit": 36
          }
        ],
        "preferences": {
          "engage": 6,
          "guard": 2,
          "hold": 4,
          "withdraw": 3
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:unpaid-shield-unpaid-shield-erenna-veld",
        "personId": "person:companion-unpaid-shield-erenna-veld",
        "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
        "prerequisites": {
          "all": [
            "hired:unpaid-shield-erenna-veld"
          ],
          "any": [],
          "none": [
            "departed:unpaid-shield-erenna-veld"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:unpaid-shield-unpaid-shield-erenna-veld",
          "status": "achieved",
          "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
          "effects": {
            "add": [
              "obligation-resolved:unpaid-shield-erenna-veld",
              "loyalty-proven:unpaid-shield-erenna-veld"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:unpaid-shield-unpaid-shield-erenna-veld",
          "status": "compromised",
          "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
          "effects": {
            "add": [
              "obligation-compromised:unpaid-shield-erenna-veld"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:unpaid-shield-unpaid-shield-erenna-veld",
          "status": "abandoned",
          "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
          "effects": {
            "add": [
              "departed:unpaid-shield-erenna-veld"
            ],
            "remove": [
              "companion-active:unpaid-shield-erenna-veld"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "ask",
            "label": "Speak with Erenna Veld (The Unpaid Shield)"
          },
          "text": "My father signed for army bread in a bad winter. Thirty years on, the depot says he still owes it. I fight for money. I do not fight for officers.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:unpaid-shield-erenna-veld",
              "rejected:unpaid-shield-erenna-veld",
              "dead:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "met:unpaid-shield-erenna-veld"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "offer",
            "label": "Agree to twelve-cut wage in escrow"
          },
          "text": "Done. You point, I decide. Nobody salutes. If the price is wrong, I tell you before the blades come out.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Erenna Veld.",
          "prerequisites": {
            "all": [
              "met:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "hired:unpaid-shield-erenna-veld",
              "dead:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "hired:unpaid-shield-erenna-veld",
              "companion-active:unpaid-shield-erenna-veld"
            ],
            "remove": [
              "available:unpaid-shield-erenna-veld"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "escrow:guaranteed-wage"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No chase. A chase is how sergeants get buried and officers get medals.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-erenna-veld",
              "departed:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:unpaid-shield-erenna-veld"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "No. I fight where the fight is, not wherever you happen to stand.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-erenna-veld",
              "departed:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:unpaid-shield-erenna-veld"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Good. Best order I have heard all year.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-erenna-veld",
              "departed:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:unpaid-shield-erenna-veld"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "At the court there is a second toll on the stair. Get it struck. Officers love striking things when someone else did the reading.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:unpaid-shield-erenna-veld"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-unpaid-shield-erenna-veld",
          "intention": {
            "kind": "leave",
            "label": "Erenna Veld departs over contract violation"
          },
          "text": "You took the porters’ four cuts. That is exactly what the quartermaster did to my father. I am out.",
          "disclosure": "essential",
          "firstEncounterSummary": "Erenna Veld leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-erenna-veld",
              "boundary-breached:unpaid-shield-erenna-veld"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-erenna-veld",
              "departed:unpaid-shield-erenna-veld"
            ]
          },
          "effects": {
            "add": [
              "departed:unpaid-shield-erenna-veld"
            ],
            "remove": [
              "companion-active:unpaid-shield-erenna-veld"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-unpaid-shield-erenna-veld",
        "name": "Erenna Veld",
        "templateId": "unpaid-shield",
        "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
        "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
        "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
      },
      "absenceResponse": {
        "companionId": "person:companion-unpaid-shield-erenna-veld",
        "name": "Erenna Veld",
        "templateId": "unpaid-shield",
        "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
        "departureLine": "You took the porters’ four cuts. That is exactly what the quartermaster did to my father. I am out.",
        "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
      },
      "voice": {
        "voiceId": "shield-sergeant",
        "care": {
          "offered": "Good. A {item} before the blood starts. Someone has thought ahead.",
          "treat": "Taking a moment. Keep that point away from me.",
          "remember": "{giver} remembered that a shield has a person behind it. Brought supplies for that person.",
          "aid": "Fight is over. Sit down before you fall down. I can dress that.",
          "rememberAid": "I dressed {patient}’s wounds after the fighting. Officers never taught me that part of the job."
        },
        "manner": "Ex-sergeant; blunt, clipped orders; contempt for officers; bold, keeps own counsel.",
        "temperament": {
          "boldness": 7,
          "loyalty": 3
        },
        "obligation": "Wages go against an old man’s ration bond at the depot. Paid to fight, not to charge.",
        "opening": "My father signed for army bread in a bad winter. Thirty years on, the depot says he still owes it. I fight for money. I do not fight for officers.",
        "hire": "Done. You point, I decide. Nobody salutes. If the price is wrong, I tell you before the blades come out.",
        "hired": "Still here. Still paid. You say where; I say whether.",
        "refusal": "Charge on your own coin. Nobody pays me enough for that.",
        "afterFight": {
          "guard": "Clean enough. He waited too long to draw, which means he never meant it. Noll hires men who hope.",
          "tunnel": "Kept stoking with a spear in it. I have had recruits with less discipline. Did not like watching it."
        },
        "moment": {
          "request": "At the court there is a second toll on the stair. Get it struck. Officers love striking things when someone else did the reading.",
          "kept": "Struck. See? Somebody had to put it in front of them. Porters get nothing unless it is written down first.",
          "broken": "You took the porters’ four cuts. That is exactly what the quartermaster did to my father. I am out."
        },
        "judgment": {
          "good": "Paid. The old man’s bond comes down a season. I will tell him an outsider did it. He will not believe me.",
          "bad": "You sold the kilns their protection. I have served men who did that. I do not serve them twice.",
          "depart": "Go, then. I finish contracts. This one ends when the escrow opens, and I am staying until it does.",
          "mourning": "Died on your feet. More than most officers manage. The escrow pays; I will drink the first cut to you."
        },
        "discuss": {
          "guard": {
            "accepted": "Fine. Stay behind my shield and do not wander.",
            "refused": "No. I fight where the fight is, not wherever you happen to stand."
          },
          "engage": {
            "accepted": "If he breaks, I follow. Soldiers who break keep running.",
            "refused": "No chase. A chase is how sergeants get buried and officers get medals."
          },
          "withdraw": {
            "accepted": "Good. Best order I have heard all year.",
            "refused": "I pick my own retreat. I have picked better ones than yours."
          }
        },
        "barks": {
          "engage": "He broke. Going in.",
          "guard": "Behind me. Now.",
          "hold": "Hold. Let him tire.",
          "withdraw": "Pulling out. Not dying here.",
          "defend": "Full swing. I know that drill."
        },
        "returning": {
          "kept": "Another outsider. The last one I worked for lived, paid, and never once asked for a salute. You have a lot to live up to.",
          "mourned": "Last outsider I worked for died at the kilns. Not my fault, not theirs either. Let us see about you.",
          "absent": "Went back to the depot to argue the father’s bond in person. Said outsiders pay late and die early."
        }
      }
    }
  ],
  "military": [
    {
      "candidateKey": "unpaid-shield-ressa-serrat",
      "templateId": "unpaid-shield",
      "templateTitle": "The Unpaid Shield",
      "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
      "culture": "Veyrathi",
      "name": "Ressa Serrat",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:knife-belt"
      ],
      "person": {
        "id": "person:companion-unpaid-shield-ressa-serrat",
        "lineageKey": "lineage:unpaid-shield-ressa-serrat",
        "presentationKey": "presentation:actor-unpaid-shield-rotation",
        "kinshipKeys": [
          "kinship:unpaid-shield-ressa-serrat-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Ressa Serrat",
          "origin": "disgraced-legionary",
          "culture": "Veyrathi",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "shield-discipline",
            "spear-drill"
          ],
          "abilities": [
            "brace-drill"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Veyrathi customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-unpaid-shield-ressa-serrat",
        "temperament": {
          "boldness": 5,
          "loyalty": 9
        },
        "obligations": [
          {
            "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-ressa-serrat",
            "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "My son needs me whole more than you need that blow landed. I am holding my ground."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-ressa-serrat",
            "kind": "danger-limit",
            "dangerLimit": 36
          }
        ],
        "preferences": {
          "engage": 5,
          "guard": 8,
          "hold": 5,
          "withdraw": 5
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
        "personId": "person:companion-unpaid-shield-ressa-serrat",
        "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
        "prerequisites": {
          "all": [
            "hired:unpaid-shield-ressa-serrat"
          ],
          "any": [],
          "none": [
            "departed:unpaid-shield-ressa-serrat"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
          "status": "achieved",
          "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
          "effects": {
            "add": [
              "obligation-resolved:unpaid-shield-ressa-serrat",
              "loyalty-proven:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
          "status": "compromised",
          "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
          "effects": {
            "add": [
              "obligation-compromised:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:unpaid-shield-unpaid-shield-ressa-serrat",
          "status": "abandoned",
          "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
          "effects": {
            "add": [
              "departed:unpaid-shield-ressa-serrat"
            ],
            "remove": [
              "companion-active:unpaid-shield-ressa-serrat"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "ask",
            "label": "Speak with Ressa Serrat (The Unpaid Shield)"
          },
          "text": "They took my son into depot service for a debt I signed. In the camps we said a shield is only as good as the arm behind it. Mine is for hire until he is home.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:unpaid-shield-ressa-serrat",
              "rejected:unpaid-shield-ressa-serrat",
              "dead:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "met:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "offer",
            "label": "Agree to twelve-cut wage in escrow"
          },
          "text": "Then we are a pair until the milestone. In the camps that meant something. I will make it mean something here.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Ressa Serrat.",
          "prerequisites": {
            "all": [
              "met:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "hired:unpaid-shield-ressa-serrat",
              "dead:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "hired:unpaid-shield-ressa-serrat",
              "companion-active:unpaid-shield-ressa-serrat"
            ],
            "remove": [
              "available:unpaid-shield-ressa-serrat"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "escrow:guaranteed-wage"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No. A chase is how mothers lose sons. I will not run after him.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-ressa-serrat",
              "departed:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Always. Keep my shoulder in sight and we will both see supper.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-ressa-serrat",
              "departed:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Agreed. There is no shame in coming home.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-ressa-serrat",
              "departed:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "At the court, ask them to strike the second toll. We used to say an unfair tax is a slow wound. The porters have been bleeding on that stair for a year.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:unpaid-shield-ressa-serrat"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-unpaid-shield-ressa-serrat",
          "intention": {
            "kind": "leave",
            "label": "Ressa Serrat departs over contract violation"
          },
          "text": "You took from the porters’ bowl. We never took from our own. I cannot march beside that.",
          "disclosure": "essential",
          "firstEncounterSummary": "Ressa Serrat leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-ressa-serrat",
              "boundary-breached:unpaid-shield-ressa-serrat"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-ressa-serrat",
              "departed:unpaid-shield-ressa-serrat"
            ]
          },
          "effects": {
            "add": [
              "departed:unpaid-shield-ressa-serrat"
            ],
            "remove": [
              "companion-active:unpaid-shield-ressa-serrat"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-unpaid-shield-ressa-serrat",
        "name": "Ressa Serrat",
        "templateId": "unpaid-shield",
        "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
        "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
        "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
      },
      "absenceResponse": {
        "companionId": "person:companion-unpaid-shield-ressa-serrat",
        "name": "Ressa Serrat",
        "templateId": "unpaid-shield",
        "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
        "departureLine": "You took from the porters’ bowl. We never took from our own. I cannot march beside that.",
        "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
      },
      "voice": {
        "voiceId": "shield-camp",
        "care": {
          "offered": "We pack for the one who falls behind. Thank you for the {item}.",
          "treat": "A little room, friends. We still have walking to do.",
          "remember": "{giver} put medicine in my hand before asking for my shield. Good camp manners.",
          "aid": "The fighting is done, friend. Sit beside me. We tend the one who needs it.",
          "rememberAid": "I tended {patient} after the blades were quiet. That is what a camp is for."
        },
        "manner": "Formal and warm; old camp sayings; talks in 'we'; steady, deeply loyal.",
        "temperament": {
          "boldness": 5,
          "loyalty": 9
        },
        "obligation": "A son bound into depot service for a signed debt; every wage goes toward bringing him home. No unpaid assaults.",
        "opening": "They took my son into depot service for a debt I signed. In the camps we said a shield is only as good as the arm behind it. Mine is for hire until he is home.",
        "hire": "Then we are a pair until the milestone. In the camps that meant something. I will make it mean something here.",
        "hired": "We walk together until the milestone. In the camps we said the second pair of eyes sees the knife. Mine are open.",
        "refusal": "My son needs me whole more than you need that blow landed. I am holding my ground.",
        "afterFight": {
          "guard": "Sit, if you need to. The first one you kill stays with you. Mine still does. We keep going anyway.",
          "tunnel": "Someone’s child, once. Someone’s pair of hands. I hope whoever set it to work has to look at it."
        },
        "moment": {
          "request": "At the court, ask them to strike the second toll. We used to say an unfair tax is a slow wound. The porters have been bleeding on that stair for a year.",
          "kept": "Struck. You have closed a wound, in a small way. The camps would have drunk to you.",
          "broken": "You took from the porters’ bowl. We never took from our own. I cannot march beside that."
        },
        "judgment": {
          "good": "Paid, and to the right desk. My son comes home a season early. You will always have a place at my fire.",
          "bad": "You paid for a repair with the dead. In the camps that was the one thing we buried people for. I am leaving.",
          "depart": "Go safely. I will stay until the account is closed; a pair finishes what it starts, even halved.",
          "mourning": "We were a pair. I brought you this far and no further. I will stand at your name the way we stood for ours."
        },
        "discuss": {
          "guard": {
            "accepted": "Always. Keep my shoulder in sight and we will both see supper.",
            "refused": "Not this time. The ground wants me elsewhere; trust the arm, not the distance."
          },
          "engage": {
            "accepted": "If the gap is honest, we take it together.",
            "refused": "No. A chase is how mothers lose sons. I will not run after him."
          },
          "withdraw": {
            "accepted": "Agreed. There is no shame in coming home.",
            "refused": "I do not leave people behind. Ask me something else."
          }
        },
        "barks": {
          "engage": "With me. Now, together.",
          "guard": "Stay in my shadow.",
          "hold": "Plant your feet. We hold.",
          "withdraw": "Back, slowly. Nobody runs.",
          "defend": "Set your feet, as we did in camp. I remember."
        },
        "returning": {
          "kept": "The outsider before you came through alive, and I was proud to walk beside them. Sit a moment. Tell me what brings you down the same stair.",
          "mourned": "I marched with the last outsider until the kilns took them. I still set a place for that name. I would rather not set another.",
          "absent": "Went north to wait at the depot gate for the son. Left word that outsiders spend their pairs too easily."
        }
      }
    },
    {
      "candidateKey": "displaced-mason-yoren-en-keth",
      "templateId": "displaced-mason",
      "templateTitle": "The Displaced Mason",
      "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
      "culture": "Talruni",
      "name": "Yoren En Keth",
      "equipment": [
        "item:blade-iron",
        "item:knife-belt",
        "item:gambeson",
        "item:hook-sluicekeeper"
      ],
      "person": {
        "id": "person:companion-displaced-mason-yoren-en-keth",
        "lineageKey": "lineage:displaced-mason-yoren-en-keth",
        "presentationKey": "presentation:actor-outsider-axe-rotation",
        "kinshipKeys": [
          "kinship:displaced-mason-yoren-en-keth-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Yoren En Keth",
          "origin": "escaped-worker",
          "culture": "Talruni",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "quarry-masonry",
            "structural-knowledge"
          ],
          "abilities": [
            "pry-pawl",
            "cleave"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Talruni customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-displaced-mason-yoren-en-keth",
        "temperament": {
          "boldness": 2,
          "loyalty": 9
        },
        "obligations": [
          {
            "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-yoren-en-keth",
            "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "I will not go at him there; the whole floor is poorly footed. I will keep the way back clear."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:displaced-mason-refuse-reckless-charge-displaced-mason-yoren-en-keth",
            "kind": "refuse-goal",
            "goal": "engage"
          }
        ],
        "preferences": {
          "engage": 1,
          "guard": 8,
          "hold": 8,
          "withdraw": 9
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:displaced-mason-displaced-mason-yoren-en-keth",
        "personId": "person:companion-displaced-mason-yoren-en-keth",
        "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
        "prerequisites": {
          "all": [
            "hired:displaced-mason-yoren-en-keth"
          ],
          "any": [],
          "none": [
            "departed:displaced-mason-yoren-en-keth"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:displaced-mason-displaced-mason-yoren-en-keth",
          "status": "achieved",
          "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
          "effects": {
            "add": [
              "obligation-resolved:displaced-mason-yoren-en-keth",
              "loyalty-proven:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:displaced-mason-displaced-mason-yoren-en-keth",
          "status": "compromised",
          "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
          "effects": {
            "add": [
              "obligation-compromised:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:displaced-mason-displaced-mason-yoren-en-keth",
          "status": "abandoned",
          "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
          "effects": {
            "add": [
              "departed:displaced-mason-yoren-en-keth"
            ],
            "remove": [
              "companion-active:displaced-mason-yoren-en-keth"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "ask",
            "label": "Speak with Yoren En Keth (The Displaced Mason)"
          },
          "text": "Excuse me, are you hiring? I set stone for the public works until the works stopped. I am careful, which is not the same as slow. I only ask that we do not damage anything people need.",
          "disclosure": "essential",
          "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:displaced-mason-yoren-en-keth",
              "rejected:displaced-mason-yoren-en-keth",
              "dead:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "met:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "offer",
            "label": "Guarantee twelve cuts and swear not to harm civil works"
          },
          "text": "Thank you. I will write the twelve cuts down and send them home tonight. If I see a crack, I will say so, even when it is inconvenient.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Yoren En Keth.",
          "prerequisites": {
            "all": [
              "met:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "hired:displaced-mason-yoren-en-keth",
              "dead:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "hired:displaced-mason-yoren-en-keth",
              "companion-active:displaced-mason-yoren-en-keth"
            ],
            "remove": [
              "available:displaced-mason-yoren-en-keth"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "guarantee:civil-infrastructure"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "I would rather not. Chasing people is how you fall through floors.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-yoren-en-keth",
              "departed:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Yes, of course. I will keep to your side and tell you where the floor is soft.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-yoren-en-keth",
              "departed:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Yes. Good. I would like that very much.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-yoren-en-keth",
              "departed:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "That plank is below the red mark. Two cuts buys timber to wedge it. If the pawl goes up instead, the water tears it loose. People live behind there.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:displaced-mason-yoren-en-keth"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-displaced-mason-yoren-en-keth",
          "intention": {
            "kind": "leave",
            "label": "Yoren En Keth departs over contract violation"
          },
          "text": "The pawl. I asked you. I cannot stay while the water is in their bedding. I am going to help.",
          "disclosure": "essential",
          "firstEncounterSummary": "Yoren En Keth leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-yoren-en-keth",
              "boundary-breached:displaced-mason-yoren-en-keth"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-yoren-en-keth",
              "departed:displaced-mason-yoren-en-keth"
            ]
          },
          "effects": {
            "add": [
              "departed:displaced-mason-yoren-en-keth"
            ],
            "remove": [
              "companion-active:displaced-mason-yoren-en-keth"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-displaced-mason-yoren-en-keth",
        "name": "Yoren En Keth",
        "templateId": "displaced-mason",
        "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
        "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
        "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
      },
      "absenceResponse": {
        "companionId": "person:companion-displaced-mason-yoren-en-keth",
        "name": "Yoren En Keth",
        "templateId": "displaced-mason",
        "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
        "departureLine": "The pawl. I asked you. I cannot stay while the water is in their bedding. I am going to help.",
        "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
      },
      "voice": {
        "voiceId": "mason-plumb",
        "care": {
          "offered": "Thank you for the {item}. I was worried about being a burden if I got hurt.",
          "treat": "Please, just a little space. I can manage the wound.",
          "remember": "{giver} gave up their own supplies for me. I still measure people against that kindness.",
          "aid": "Please sit. You have lost too much blood. I have supplies; let me help.",
          "rememberAid": "I was frightened by how badly {patient} was hurt. I used my supplies to tend the wounds."
        },
        "manner": "Gentle and anxious; exact about loads and measures; apologises; cautious, very loyal.",
        "temperament": {
          "boldness": 2,
          "loyalty": 9
        },
        "obligation": "Wages for a mother and an aunt in the quarry barracks. Refuses to damage walls, drains or walkways.",
        "opening": "Excuse me, are you hiring? I set stone for the public works until the works stopped. I am careful, which is not the same as slow. I only ask that we do not damage anything people need.",
        "hire": "Thank you. I will write the twelve cuts down and send them home tonight. If I see a crack, I will say so, even when it is inconvenient.",
        "hired": "I am here. Sorry. If anything we pass looks cracked, I will tell you, even if it slows us.",
        "refusal": "I will not go at him there; the whole floor is poorly footed. I will keep the way back clear.",
        "afterFight": {
          "guard": "Are you hurt? Let me see the arm. The floor held, at least. I watched the joists the whole time; I could not help it.",
          "tunnel": "The tunnel mouth held, which I was worried about. The body did not. I hope someone knows who it was."
        },
        "moment": {
          "request": "That plank is below the red mark. Two cuts buys timber to wedge it. If the pawl goes up instead, the water tears it loose. People live behind there.",
          "kept": "It sits true. Two cuts. I measured it twice while you were not looking. It will carry a barrow now.",
          "broken": "The pawl. I asked you. I cannot stay while the water is in their bedding. I am going to help."
        },
        "judgment": {
          "good": "Everything I was worried about is still standing. That almost never happens. My mother will say I exaggerated.",
          "bad": "It was not an accident, and it was not necessary. I will take my wages and go. I am sorry.",
          "depart": "You are going now? All right. I will stay and see the escrow closed properly.",
          "mourning": "I was watching the ceiling. I should have been watching you. I will see your name entered correctly."
        },
        "discuss": {
          "guard": {
            "accepted": "Yes, of course. I will keep to your side and tell you where the floor is soft.",
            "refused": "I would, but I am more use watching the roof. Please trust me on that."
          },
          "engage": {
            "accepted": "Only if the footing is good. I will look before I step.",
            "refused": "I would rather not. Chasing people is how you fall through floors."
          },
          "withdraw": {
            "accepted": "Yes. Good. I would like that very much.",
            "refused": "Not while the drain wall is loaded like that. If I leave, it goes."
          }
        },
        "barks": {
          "engage": "Footing is good. Going.",
          "guard": "Stay by me. Mind the slab.",
          "hold": "Holding here. It is sound.",
          "withdraw": "The floor is going. Back, please.",
          "defend": "Wait. I can see where that is going."
        },
        "returning": {
          "kept": "You are the new one? The last outsider who hired me kept every wall standing. I still think about that walkway. Are you careful?",
          "mourned": "I worked for the outsider before you. They died at the kilns. I measured everything and it did not help. Forgive me, that is not your problem.",
          "absent": "Back at the barracks, repairing what the water took. Told Nessa that outsiders pay for damage they could have avoided."
        }
      }
    },
    {
      "candidateKey": "towpath-scout-dema-sarn",
      "templateId": "towpath-scout",
      "templateTitle": "The Towpath Scout",
      "archetype": "A ferry worker or canal guide selling local knowledge after losing regular work. Notices routes, uses a bow or javelins, values discretion, and refuses to expose escape routes used by vulnerable people.",
      "culture": "Orsene",
      "name": "Dema Sarn",
      "equipment": [
        "item:bow-ash",
        "item:knife-belt",
        "item:satchel",
        "item:field-dressing"
      ],
      "person": {
        "id": "person:companion-towpath-scout-dema-sarn",
        "lineageKey": "lineage:towpath-scout-dema-sarn",
        "presentationKey": "presentation:actor-towpath-scout-rotation",
        "kinshipKeys": [
          "kinship:towpath-scout-dema-sarn-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Dema Sarn",
          "origin": "escaped-worker",
          "culture": "Orsene",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "towpath-recon",
            "skirmish-archery"
          ],
          "abilities": [
            "loose-arrow",
            "quick-cut"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 8,
          "maxHp": 8,
          "allegiances": [],
          "oaths": [
            "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Orsene customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-towpath-scout-dema-sarn",
        "temperament": {
          "boldness": 7,
          "loyalty": 2
        },
        "obligations": [
          {
            "id": "obligation:towpath-scout-towpath-escape-routes-towpath-scout-dema-sarn",
            "description": "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "That one is not worth the arrow. Also, I would like to live. Mostly the second thing."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:towpath-scout-refuse-open-charge-towpath-scout-dema-sarn",
            "kind": "non-negotiable-topic",
            "topic": "engage"
          }
        ],
        "preferences": {
          "engage": 6,
          "guard": 2,
          "hold": 3,
          "withdraw": 4
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:towpath-scout-towpath-scout-dema-sarn",
        "personId": "person:companion-towpath-scout-dema-sarn",
        "description": "Guide four fugitive families past the toll chain without exposing the hidden culvert to the bailiffs.",
        "prerequisites": {
          "all": [
            "hired:towpath-scout-dema-sarn"
          ],
          "any": [],
          "none": [
            "departed:towpath-scout-dema-sarn"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:towpath-scout-towpath-scout-dema-sarn",
          "status": "achieved",
          "summary": "Guided four families past the toll chain under cover of morning silt fog without alerting the watch.",
          "effects": {
            "add": [
              "obligation-resolved:towpath-scout-dema-sarn",
              "loyalty-proven:towpath-scout-dema-sarn"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:towpath-scout-towpath-scout-dema-sarn",
          "status": "compromised",
          "summary": "Traded an obsolete bypass route to the customs inspector to divert attention from the active cut.",
          "effects": {
            "add": [
              "obligation-compromised:towpath-scout-dema-sarn"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:towpath-scout-towpath-scout-dema-sarn",
          "status": "abandoned",
          "summary": "Fled into the reeds after the player attempted to sell the towpath map to the basin toll collector.",
          "effects": {
            "add": [
              "departed:towpath-scout-dema-sarn"
            ],
            "remove": [
              "companion-active:towpath-scout-dema-sarn"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-towpath-scout-dema-sarn",
          "intention": {
            "kind": "ask",
            "label": "Speak with Dema Sarn (The Towpath Scout)"
          },
          "text": "You look lost, which is good for business. Directions cost a cut. Short cuts cost more. The one path nobody sells is not for sale at all, so do not ask.",
          "disclosure": "essential",
          "firstEncounterSummary": "Engage a quiet canal guide who knows unseen routes through the flooded terraces.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:towpath-scout-dema-sarn",
              "rejected:towpath-scout-dema-sarn",
              "dead:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "met:towpath-scout-dema-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-towpath-scout-dema-sarn",
          "intention": {
            "kind": "offer",
            "label": "Pledge secrecy regarding escape culverts and pay ten cuts"
          },
          "text": "Twelve cuts! You have bought yourself a guide, a good bow and a terrible sense of humour. The humour is free.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Dema Sarn.",
          "prerequisites": {
            "all": [
              "met:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "hired:towpath-scout-dema-sarn",
              "dead:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "hired:towpath-scout-dema-sarn",
              "companion-active:towpath-scout-dema-sarn"
            ],
            "remove": [
              "available:towpath-scout-dema-sarn"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "silence:escape-routes"
          ],
          "socialDifficulty": 2
        },
        {
          "id": "dialogue:approach-engage-towpath-scout-dema-sarn",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "Chase him? For twelve cuts? You have seen my prices.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-dema-sarn",
              "departed:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:towpath-scout-dema-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-towpath-scout-dema-sarn",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Close is where arrows go. I prefer somewhere arrows are not.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-dema-sarn",
              "departed:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:towpath-scout-dema-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-towpath-scout-dema-sarn",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Now that is a plan I can sell. I will even throw in the exit.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-dema-sarn",
              "departed:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:towpath-scout-dema-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-towpath-scout-dema-sarn",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "Here is some free advice, which is rare from me. The drain path stays off your paper. Sell anything you like. Not that.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:towpath-scout-dema-sarn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-towpath-scout-dema-sarn",
          "intention": {
            "kind": "leave",
            "label": "Dema Sarn departs over contract violation"
          },
          "text": "Six cuts for a family’s way home. You undercharged, and you sold the wrong thing. Goodbye.",
          "disclosure": "essential",
          "firstEncounterSummary": "Dema Sarn leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:towpath-scout-dema-sarn",
              "boundary-breached:towpath-scout-dema-sarn"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-dema-sarn",
              "departed:towpath-scout-dema-sarn"
            ]
          },
          "effects": {
            "add": [
              "departed:towpath-scout-dema-sarn"
            ],
            "remove": [
              "companion-active:towpath-scout-dema-sarn"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-towpath-scout-dema-sarn",
        "name": "Dema Sarn",
        "templateId": "towpath-scout",
        "memorialNote": "An ash bow with a worn cord, wrapped in greased oilcloth. Inside the quiver is a charcoal map of water depths, unmarked by any official seal.",
        "campNotice": "A bundle of willow cord hangs by the cold brazier. The scout didn't return from the evening canal watch.",
        "witnessReaction": "She slipped through thirty patrols without a ripple. It took a blind crossbow in the fog to stop her."
      },
      "absenceResponse": {
        "companionId": "person:companion-towpath-scout-dema-sarn",
        "name": "Dema Sarn",
        "templateId": "towpath-scout",
        "reason": "Boundary violated: secret towpath escape route betrayed to canal guards.",
        "departureLine": "Six cuts for a family’s way home. You undercharged, and you sold the wrong thing. Goodbye.",
        "campNotice": "A footprint in wet clay near the canal edge, leading into the deep reed bed."
      },
      "voice": {
        "voiceId": "scout-patter",
        "care": {
          "offered": "A {item}, and no extra charge? Dangerous precedent. I accept.",
          "treat": "One moment. Bleeding is expensive.",
          "remember": "{giver} gave me medicine without adding a term to the contract. I checked.",
          "aid": "You look expensive to replace. Sit down; the medicine is on me.",
          "rememberAid": "I spent my own medicine on {patient}. No invoice. Some things ruin the joke."
        },
        "manner": "Jokey mercenary patter; prices everything; steel about the families; bold, independent.",
        "temperament": {
          "boldness": 7,
          "loyalty": 2
        },
        "obligation": "Pays well, talks cheap, and sells anything except the families’ route.",
        "opening": "You look lost, which is good for business. Directions cost a cut. Short cuts cost more. The one path nobody sells is not for sale at all, so do not ask.",
        "hire": "Twelve cuts! You have bought yourself a guide, a good bow and a terrible sense of humour. The humour is free.",
        "hired": "Your guide, already paid for. Questions are free today. Answers too, mostly.",
        "refusal": "That one is not worth the arrow. Also, I would like to live. Mostly the second thing.",
        "afterFight": {
          "guard": "Well. That was a very expensive doorway. Noll will want a receipt. I would love to watch him write it.",
          "tunnel": "It kept working after it died. I have met foremen like that. Do not tell them I said so."
        },
        "moment": {
          "request": "Here is some free advice, which is rare from me. The drain path stays off your paper. Sell anything you like. Not that.",
          "kept": "Look at you, leaving money on the table. I might have misjudged you. Do not let it go to your head.",
          "broken": "Six cuts for a family’s way home. You undercharged, and you sold the wrong thing. Goodbye."
        },
        "judgment": {
          "good": "Paid in full, and I did not have to steal anything. I feel almost respectable. It will pass.",
          "bad": "I sell a lot of things. I have never sold the dead back to their own town. Keep your pass. I am going.",
          "depart": "Off already? Nobody tips anymore. I will stay and watch the escrow open; I like seeing money move.",
          "mourning": "Well, that is bad for business. And for you, mostly. I will tell them you paid on time. It is the nicest thing I know how to say."
        },
        "discuss": {
          "guard": {
            "accepted": "Fine, I will stay close. Close costs extra; I will put it on your account.",
            "refused": "Close is where arrows go. I prefer somewhere arrows are not."
          },
          "engage": {
            "accepted": "If he runs, I shoot. Running is my favourite kind of target.",
            "refused": "Chase him? For twelve cuts? You have seen my prices."
          },
          "withdraw": {
            "accepted": "Now that is a plan I can sell. I will even throw in the exit.",
            "refused": "I leave when I leave. That part of me is not for hire."
          }
        },
        "barks": {
          "engage": "Open target. Lovely.",
          "guard": "Stay put. I have the angle.",
          "hold": "Nobody move. Especially me.",
          "withdraw": "Time to go. Follow the expensive one.",
          "defend": "You will have to earn that cut."
        },
        "returning": {
          "kept": "Another outsider? The last one paid me well and lived, which is the best review I ever got. Want the same service?",
          "mourned": "My last client died down in the kilns. Paid in advance, luckily. That is a joke. Mostly. Hire me and I will try harder.",
          "absent": "Raised prices past anything an outsider pays, on purpose. Told the stall-keepers the last one sold something that was not for sale."
        }
      }
    }
  ],
  "harbour": [
    {
      "candidateKey": "unpaid-shield-merva-en-or",
      "templateId": "unpaid-shield",
      "templateTitle": "The Unpaid Shield",
      "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
      "culture": "Talruni",
      "name": "Merva En Or",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:knife-belt"
      ],
      "person": {
        "id": "person:companion-unpaid-shield-merva-en-or",
        "lineageKey": "lineage:unpaid-shield-merva-en-or",
        "presentationKey": "presentation:actor-unpaid-shield-rotation",
        "kinshipKeys": [
          "kinship:unpaid-shield-merva-en-or-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Merva En Or",
          "origin": "disgraced-legionary",
          "culture": "Talruni",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "shield-discipline",
            "spear-drill"
          ],
          "abilities": [
            "brace-drill"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Talruni customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-unpaid-shield-merva-en-or",
        "temperament": {
          "boldness": 8,
          "loyalty": 7
        },
        "obligations": [
          {
            "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-merva-en-or",
            "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "I would, truly, but my brother does not get paid for my bravery. I am staying out of that one."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:unpaid-shield-refuse-unpaid-slaughter-unpaid-shield-merva-en-or",
            "kind": "refuse-goal",
            "goal": "engage"
          }
        ],
        "preferences": {
          "engage": 7,
          "guard": 7,
          "hold": 3,
          "withdraw": 1
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:unpaid-shield-unpaid-shield-merva-en-or",
        "personId": "person:companion-unpaid-shield-merva-en-or",
        "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
        "prerequisites": {
          "all": [
            "hired:unpaid-shield-merva-en-or"
          ],
          "any": [],
          "none": [
            "departed:unpaid-shield-merva-en-or"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:unpaid-shield-unpaid-shield-merva-en-or",
          "status": "achieved",
          "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
          "effects": {
            "add": [
              "obligation-resolved:unpaid-shield-merva-en-or",
              "loyalty-proven:unpaid-shield-merva-en-or"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:unpaid-shield-unpaid-shield-merva-en-or",
          "status": "compromised",
          "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
          "effects": {
            "add": [
              "obligation-compromised:unpaid-shield-merva-en-or"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:unpaid-shield-unpaid-shield-merva-en-or",
          "status": "abandoned",
          "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
          "effects": {
            "add": [
              "departed:unpaid-shield-merva-en-or"
            ],
            "remove": [
              "companion-active:unpaid-shield-merva-en-or"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "ask",
            "label": "Speak with Merva En Or (The Unpaid Shield)"
          },
          "text": "I have a shield, a good arm, and a brother pushing concession carts until his bond is clear. Ask me anything. Please ask me something.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:unpaid-shield-merva-en-or",
              "rejected:unpaid-shield-merva-en-or",
              "dead:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "met:unpaid-shield-merva-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "offer",
            "label": "Agree to twelve-cut wage in escrow"
          },
          "text": "Twelve cuts! Right. I will be very good. Useful, I mean. Useful, and I will try not to talk the whole way.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Merva En Or.",
          "prerequisites": {
            "all": [
              "met:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "hired:unpaid-shield-merva-en-or",
              "dead:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "hired:unpaid-shield-merva-en-or",
              "companion-active:unpaid-shield-merva-en-or"
            ],
            "remove": [
              "available:unpaid-shield-merva-en-or"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "escrow:guaranteed-wage"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "I want to. I really do. But chasing is unpaid, and my brother is not.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-merva-en-or",
              "departed:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:unpaid-shield-merva-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Yes! I mean, yes. Close. Right beside you.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-merva-en-or",
              "departed:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:unpaid-shield-merva-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "All right. Living is good. My brother would be furious otherwise.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-merva-en-or",
              "departed:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:unpaid-shield-merva-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "At the court, could you ask about the stair toll? They charge it twice. My brother paid it twice on every cart.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:unpaid-shield-merva-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-unpaid-shield-merva-en-or",
          "intention": {
            "kind": "leave",
            "label": "Merva En Or departs over contract violation"
          },
          "text": "You took money out of the porters’ bowl. My brother’s money, near enough. I cannot stay after that. I am sorry.",
          "disclosure": "essential",
          "firstEncounterSummary": "Merva En Or leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-merva-en-or",
              "boundary-breached:unpaid-shield-merva-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-merva-en-or",
              "departed:unpaid-shield-merva-en-or"
            ]
          },
          "effects": {
            "add": [
              "departed:unpaid-shield-merva-en-or"
            ],
            "remove": [
              "companion-active:unpaid-shield-merva-en-or"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-unpaid-shield-merva-en-or",
        "name": "Merva En Or",
        "templateId": "unpaid-shield",
        "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
        "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
        "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
      },
      "absenceResponse": {
        "companionId": "person:companion-unpaid-shield-merva-en-or",
        "name": "Merva En Or",
        "templateId": "unpaid-shield",
        "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
        "departureLine": "You took money out of the porters’ bowl. My brother’s money, near enough. I cannot stay after that. I am sorry.",
        "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
      },
      "voice": {
        "voiceId": "shield-eager",
        "care": {
          "offered": "For me? A {item}. Right. I will try to need it less than you do.",
          "treat": "Still here. Just making sure the blood stays here too.",
          "remember": "{giver} shared their medicine with me. I had thought the twelve cuts were all I mattered for.",
          "aid": "You are bleeding. A lot. Wait, I kept the medicine. Let me help.",
          "rememberAid": "{patient} was badly hurt. I had medicine, and for once I knew exactly what to do."
        },
        "manner": "Young and earnest; talks fast; jokes at his own expense; bold and loyal.",
        "temperament": {
          "boldness": 8,
          "loyalty": 7
        },
        "obligation": "Earning out a brother’s bond on the concession carts. Brave for pay, not for free.",
        "opening": "I have a shield, a good arm, and a brother pushing concession carts until his bond is clear. Ask me anything. Please ask me something.",
        "hire": "Twelve cuts! Right. I will be very good. Useful, I mean. Useful, and I will try not to talk the whole way.",
        "hired": "Still with you! I have not said anything stupid for at least a whole street. Where to?",
        "refusal": "I would, truly, but my brother does not get paid for my bravery. I am staying out of that one.",
        "afterFight": {
          "guard": "Did you see him draw? I did. I thought I would be braver. I was mostly fast. Is that the same thing?",
          "tunnel": "It was still trying to feed the fire. Nobody told it to stop. I keep thinking somebody should have."
        },
        "moment": {
          "request": "At the court, could you ask about the stair toll? They charge it twice. My brother paid it twice on every cart.",
          "kept": "They struck it! I am telling my brother tonight. He will pretend not to care, and then he will tell everyone.",
          "broken": "You took money out of the porters’ bowl. My brother’s money, near enough. I cannot stay after that. I am sorry."
        },
        "judgment": {
          "good": "Paid, and not one lie in the whole account. My brother is off the carts by summer. I owe you a drink I cannot afford.",
          "bad": "You let them keep the bodies working. I thought we were on the other side of this. I am going home.",
          "depart": "You are going? I thought we would finish it. I will stay. Somebody should see the end.",
          "mourning": "I should have been closer. Two paces, like they taught us. I will carry your name to the list myself."
        },
        "discuss": {
          "guard": {
            "accepted": "Yes! I mean, yes. Close. Right beside you.",
            "refused": "Honestly, I am better out in front. Let me take the first blow."
          },
          "engage": {
            "accepted": "If he runs, I run faster. I am good at that part.",
            "refused": "I want to. I really do. But chasing is unpaid, and my brother is not."
          },
          "withdraw": {
            "accepted": "All right. Living is good. My brother would be furious otherwise.",
            "refused": "No, I am not leaving you in there. Do not ask me that again."
          }
        },
        "barks": {
          "engage": "Opening! I have got him!",
          "guard": "I am here, I am here.",
          "hold": "Standing firm. Come on, then.",
          "withdraw": "Back! Back, before it gets worse.",
          "defend": "Saw that one coming. For once."
        },
        "returning": {
          "kept": "You are the new outsider? The last one hired me too. They lived! They paid! I have been hoping someone like that would come down the stair again.",
          "mourned": "The last outsider I worked for did not come back from the kilns. I carried the name to the list. I would like not to do that twice.",
          "absent": "Went to push carts beside the brother instead. Told Melian’s patients that outsiders make promises and spend them elsewhere."
        }
      }
    },
    {
      "candidateKey": "former-mortuary-guard-orun-en-dars",
      "templateId": "former-mortuary-guard",
      "templateTitle": "The Former Mortuary Guard",
      "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
      "culture": "Talruni",
      "name": "Orun En Dars",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:oil-flask"
      ],
      "person": {
        "id": "person:companion-former-mortuary-guard-orun-en-dars",
        "lineageKey": "lineage:former-mortuary-guard-orun-en-dars",
        "presentationKey": "presentation:actor-mortuary-guard-rotation",
        "kinshipKeys": [
          "kinship:former-mortuary-guard-orun-en-dars-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Orun En Dars",
          "origin": "disgraced-legionary",
          "culture": "Talruni",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "funerary-vigil",
            "spear-drill"
          ],
          "abilities": [
            "thrust",
            "set-spear"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 9,
          "maxHp": 9,
          "allegiances": [],
          "oaths": [
            "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Talruni customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-former-mortuary-guard-orun-en-dars",
        "temperament": {
          "boldness": 6,
          "loyalty": 7
        },
        "obligations": [
          {
            "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-orun-en-dars",
            "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "I will not strike a body. I carried too many empty boxes for the people who put it to work."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:former-mortuary-guard-refuse-unlawful-desecration-former-mortuary-guard-orun-en-dars",
            "kind": "non-negotiable-topic",
            "topic": "withdraw"
          }
        ],
        "preferences": {
          "engage": 6,
          "guard": 8,
          "hold": 5,
          "withdraw": 4
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
        "personId": "person:companion-former-mortuary-guard-orun-en-dars",
        "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
        "prerequisites": {
          "all": [
            "hired:former-mortuary-guard-orun-en-dars"
          ],
          "any": [],
          "none": [
            "departed:former-mortuary-guard-orun-en-dars"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
          "status": "achieved",
          "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
          "effects": {
            "add": [
              "obligation-resolved:former-mortuary-guard-orun-en-dars",
              "loyalty-proven:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
          "status": "compromised",
          "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
          "effects": {
            "add": [
              "obligation-compromised:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-orun-en-dars",
          "status": "abandoned",
          "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
          "effects": {
            "add": [
              "departed:former-mortuary-guard-orun-en-dars"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-orun-en-dars"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "ask",
            "label": "Speak with Orun En Dars (The Former Mortuary Guard)"
          },
          "text": "I walked the coffin carts up to the kilns for two years. Light carts. I noticed. I took the wage anyway. So now I am for hire, and I will spend it undoing what I helped carry.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-orun-en-dars",
              "rejected:former-mortuary-guard-orun-en-dars",
              "dead:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "met:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "offer",
            "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
          },
          "text": "Good. Twelve cuts, and I am yours. Do not tell me a body is evidence. I have heard that one before.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Orun En Dars.",
          "prerequisites": {
            "all": [
              "met:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-orun-en-dars",
              "dead:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "hired:former-mortuary-guard-orun-en-dars",
              "companion-active:former-mortuary-guard-orun-en-dars"
            ],
            "remove": [
              "available:former-mortuary-guard-orun-en-dars"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "covenant:no-desecration"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "Not through the stations. I will not chase anyone over the dead.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-orun-en-dars",
              "departed:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Yes. Close. I have walked beside worse things than you.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-orun-en-dars",
              "departed:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Fine. But we come back. We always come back for them.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-orun-en-dars",
              "departed:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "You have the anchor copied. Undo it. Right now, while we can. I owe this one more than you do.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:former-mortuary-guard-orun-en-dars"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-former-mortuary-guard-orun-en-dars",
          "intention": {
            "kind": "leave",
            "label": "Orun En Dars departs over contract violation"
          },
          "text": "You paid for more wax. I did that once, with my silence. I will not do it again with my spear. Goodbye.",
          "disclosure": "essential",
          "firstEncounterSummary": "Orun En Dars leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-orun-en-dars",
              "boundary-breached:former-mortuary-guard-orun-en-dars"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-orun-en-dars",
              "departed:former-mortuary-guard-orun-en-dars"
            ]
          },
          "effects": {
            "add": [
              "departed:former-mortuary-guard-orun-en-dars"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-orun-en-dars"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-former-mortuary-guard-orun-en-dars",
        "name": "Orun En Dars",
        "templateId": "former-mortuary-guard",
        "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
        "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
        "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
      },
      "absenceResponse": {
        "companionId": "person:companion-former-mortuary-guard-orun-en-dars",
        "name": "Orun En Dars",
        "templateId": "former-mortuary-guard",
        "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
        "departureLine": "You paid for more wax. I did that once, with my silence. I will not do it again with my spear. Goodbye.",
        "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
      },
      "voice": {
        "voiceId": "guard-carts",
        "care": {
          "offered": "I will take the {item}. Better than pretending the blood is someone else’s problem.",
          "treat": "Not another body for a cart. Give me room.",
          "remember": "{giver} handed me medicine while I could still use it. I have carried worse things than that memory.",
          "aid": "Not another one left bleeding. Sit down. I have something for that wound.",
          "rememberAid": "I used my medicine on {patient}. This time I did more than walk beside a cart."
        },
        "manner": "Direct, confessional, angry with himself; walked the empty coffin carts for pay.",
        "temperament": {
          "boldness": 6,
          "loyalty": 7
        },
        "obligation": "Escorted empty coffins for pay and never asked. Wants the stolen dead returned, names and all.",
        "opening": "I walked the coffin carts up to the kilns for two years. Light carts. I noticed. I took the wage anyway. So now I am for hire, and I will spend it undoing what I helped carry.",
        "hire": "Good. Twelve cuts, and I am yours. Do not tell me a body is evidence. I have heard that one before.",
        "hired": "I am with you. I carried empty coffins up that road for their wage. This time I carry something back.",
        "refusal": "I will not strike a body. I carried too many empty boxes for the people who put it to work.",
        "afterFight": {
          "guard": "I knew him, a little. We drank at the same stall. He knew about the carts too. Neither of us said anything.",
          "tunnel": "I might have walked that one’s empty coffin up to the kilns. I will never know. That is the worst part."
        },
        "moment": {
          "request": "You have the anchor copied. Undo it. Right now, while we can. I owe this one more than you do.",
          "kept": "He is still. He can go home. I cannot give back two years, but I can give back him.",
          "broken": "You paid for more wax. I did that once, with my silence. I will not do it again with my spear. Goodbye."
        },
        "judgment": {
          "good": "Named and carried. It does not make up for the carts. It is still the first good thing I have done here.",
          "bad": "You chose the same thing I chose for two years. I know exactly what it costs. I will not pay it twice.",
          "depart": "Leave, then. I have walked away from this place before. I am not doing it again.",
          "mourning": "Another coffin I will walk out of the kilns. This one will not be empty. I am sorry."
        },
        "discuss": {
          "guard": {
            "accepted": "Yes. Close. I have walked beside worse things than you.",
            "refused": "No. I need room to see what is coming. I missed it once."
          },
          "engage": {
            "accepted": "If he runs, I follow. He has answers.",
            "refused": "Not through the stations. I will not chase anyone over the dead."
          },
          "withdraw": {
            "accepted": "Fine. But we come back. We always come back for them.",
            "refused": "I left once when I should have stayed. I am not leaving now."
          }
        },
        "barks": {
          "engage": "My turn. Going in.",
          "guard": "I have your back. This time.",
          "hold": "Stand here. Nothing gets carried off.",
          "withdraw": "Back. We return for them later.",
          "defend": "No. You are not putting me on that cart."
        },
        "returning": {
          "kept": "The last outsider who hired me got the dead out and walked away whole. I did not think I would see that twice. Maybe I will.",
          "mourned": "I walked the last outsider’s coffin out of the kilns myself. It was heavy. I am glad it was heavy. That is a terrible thing to be glad of.",
          "absent": "Went back to walking the carts, to count what goes into them. Says outsiders only ever look once."
        }
      }
    },
    {
      "candidateKey": "towpath-scout-vesha-an-vesh",
      "templateId": "towpath-scout",
      "templateTitle": "The Towpath Scout",
      "archetype": "A ferry worker or canal guide selling local knowledge after losing regular work. Notices routes, uses a bow or javelins, values discretion, and refuses to expose escape routes used by vulnerable people.",
      "culture": "Serekh",
      "name": "Vesha an-Vesh",
      "equipment": [
        "item:bow-ash",
        "item:knife-belt",
        "item:satchel",
        "item:field-dressing"
      ],
      "person": {
        "id": "person:companion-towpath-scout-vesha-an-vesh",
        "lineageKey": "lineage:towpath-scout-vesha-an-vesh",
        "presentationKey": "presentation:actor-towpath-scout-rotation",
        "kinshipKeys": [
          "kinship:towpath-scout-vesha-an-vesh-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Vesha an-Vesh",
          "origin": "escaped-worker",
          "culture": "Serekh",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "towpath-recon",
            "skirmish-archery"
          ],
          "abilities": [
            "loose-arrow",
            "quick-cut"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 8,
          "maxHp": 8,
          "allegiances": [],
          "oaths": [
            "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Serekh customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-towpath-scout-vesha-an-vesh",
        "temperament": {
          "boldness": 3,
          "loyalty": 8
        },
        "obligations": [
          {
            "id": "obligation:towpath-scout-towpath-escape-routes-towpath-scout-vesha-an-vesh",
            "description": "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "Not him. Sound travels. If I fight here, every bailiff on the stair learns where we came from."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:towpath-scout-danger-limit-towpath-scout-vesha-an-vesh",
            "kind": "danger-limit",
            "dangerLimit": 26
          }
        ],
        "preferences": {
          "engage": 2,
          "guard": 7,
          "hold": 7,
          "withdraw": 8
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
        "personId": "person:companion-towpath-scout-vesha-an-vesh",
        "description": "Guide four fugitive families past the toll chain without exposing the hidden culvert to the bailiffs.",
        "prerequisites": {
          "all": [
            "hired:towpath-scout-vesha-an-vesh"
          ],
          "any": [],
          "none": [
            "departed:towpath-scout-vesha-an-vesh"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
          "status": "achieved",
          "summary": "Guided four families past the toll chain under cover of morning silt fog without alerting the watch.",
          "effects": {
            "add": [
              "obligation-resolved:towpath-scout-vesha-an-vesh",
              "loyalty-proven:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
          "status": "compromised",
          "summary": "Traded an obsolete bypass route to the customs inspector to divert attention from the active cut.",
          "effects": {
            "add": [
              "obligation-compromised:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:towpath-scout-towpath-scout-vesha-an-vesh",
          "status": "abandoned",
          "summary": "Fled into the reeds after the player attempted to sell the towpath map to the basin toll collector.",
          "effects": {
            "add": [
              "departed:towpath-scout-vesha-an-vesh"
            ],
            "remove": [
              "companion-active:towpath-scout-vesha-an-vesh"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "ask",
            "label": "Speak with Vesha an-Vesh (The Towpath Scout)"
          },
          "text": "Walk softly here. The stones carry sound down to the water, and the water carries it further. I can show you the quiet ways, if you can keep them quiet.",
          "disclosure": "essential",
          "firstEncounterSummary": "Engage a quiet canal guide who knows unseen routes through the flooded terraces.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:towpath-scout-vesha-an-vesh",
              "rejected:towpath-scout-vesha-an-vesh",
              "dead:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "met:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "offer",
            "label": "Pledge secrecy regarding escape culverts and pay ten cuts"
          },
          "text": "Twelve cuts. And one promise: what I show you, you forget when anyone official asks.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Vesha an-Vesh.",
          "prerequisites": {
            "all": [
              "met:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "hired:towpath-scout-vesha-an-vesh",
              "dead:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "hired:towpath-scout-vesha-an-vesh",
              "companion-active:towpath-scout-vesha-an-vesh"
            ],
            "remove": [
              "available:towpath-scout-vesha-an-vesh"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "silence:escape-routes"
          ],
          "socialDifficulty": 2
        },
        {
          "id": "dialogue:approach-engage-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No. Noise brings more of them. I will not open that door.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-vesha-an-vesh",
              "departed:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I will stay near. You will not hear me, but I will be there.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-vesha-an-vesh",
              "departed:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Yes. I already know three ways out.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-vesha-an-vesh",
              "departed:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "The shoes on that ledge belong to people. When you write your report, leave the drain out. Let the city go on not knowing.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:towpath-scout-vesha-an-vesh"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-towpath-scout-vesha-an-vesh",
          "intention": {
            "kind": "leave",
            "label": "Vesha an-Vesh departs over contract violation"
          },
          "text": "You gave them the path. Tomorrow there will be a lantern on that ledge. I have to warn them before it arrives.",
          "disclosure": "essential",
          "firstEncounterSummary": "Vesha an-Vesh leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:towpath-scout-vesha-an-vesh",
              "boundary-breached:towpath-scout-vesha-an-vesh"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-vesha-an-vesh",
              "departed:towpath-scout-vesha-an-vesh"
            ]
          },
          "effects": {
            "add": [
              "departed:towpath-scout-vesha-an-vesh"
            ],
            "remove": [
              "companion-active:towpath-scout-vesha-an-vesh"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-towpath-scout-vesha-an-vesh",
        "name": "Vesha an-Vesh",
        "templateId": "towpath-scout",
        "memorialNote": "An ash bow with a worn cord, wrapped in greased oilcloth. Inside the quiver is a charcoal map of water depths, unmarked by any official seal.",
        "campNotice": "A bundle of willow cord hangs by the cold brazier. The scout didn't return from the evening canal watch.",
        "witnessReaction": "She slipped through thirty patrols without a ripple. It took a blind crossbow in the fog to stop her."
      },
      "absenceResponse": {
        "companionId": "person:companion-towpath-scout-vesha-an-vesh",
        "name": "Vesha an-Vesh",
        "templateId": "towpath-scout",
        "reason": "Boundary violated: secret towpath escape route betrayed to canal guards.",
        "departureLine": "You gave them the path. Tomorrow there will be a lantern on that ledge. I have to warn them before it arrives.",
        "campNotice": "A footprint in wet clay near the canal edge, leading into the deep reed bed."
      },
      "voice": {
        "voiceId": "scout-still",
        "care": {
          "offered": "I will keep the {item} dry. You may want it yourself before this is over.",
          "treat": "Quiet now. I can tend this if they stay there.",
          "remember": "When I think of {giver}, I remember the supplies they shared, and the water we crossed.",
          "aid": "Quiet now. The danger has passed. Let me see that wound.",
          "rememberAid": "I remember tending {patient} when the fighting went quiet. I had kept the medicine dry."
        },
        "manner": "Soft-spoken and watchful; talks about sound and water; cautious, loyal.",
        "temperament": {
          "boldness": 3,
          "loyalty": 8
        },
        "obligation": "Keeps the families’ hidden path out of every record. Shows you the water, never the people.",
        "opening": "Walk softly here. The stones carry sound down to the water, and the water carries it further. I can show you the quiet ways, if you can keep them quiet.",
        "hire": "Twelve cuts. And one promise: what I show you, you forget when anyone official asks.",
        "hired": "Listen before you step. The water tells me who is on the stair. I am with you.",
        "refusal": "Not him. Sound travels. If I fight here, every bailiff on the stair learns where we came from.",
        "afterFight": {
          "guard": "Listen. Nothing now. There was one set of boots in that office, and it has stopped. Breathe a little.",
          "tunnel": "The fire is quieter without it. I did not know the dead could be that loud."
        },
        "moment": {
          "request": "The shoes on that ledge belong to people. When you write your report, leave the drain out. Let the city go on not knowing.",
          "kept": "A blank space in your notes. The water keeps it. So will I.",
          "broken": "You gave them the path. Tomorrow there will be a lantern on that ledge. I have to warn them before it arrives."
        },
        "judgment": {
          "good": "The gate changed hands, and the ledge is still nobody’s business. That is the best kind of quiet.",
          "bad": "You made it quieter by removing the people who might have spoken. I know that sort of quiet. I am leaving.",
          "depart": "You go upriver. I stay by the water. Someone has to keep watch on the ledge.",
          "mourning": "I listened for you all the way down the ramp. Then I stopped hearing you. I will tell the water your name."
        },
        "discuss": {
          "guard": {
            "accepted": "I will stay near. You will not hear me, but I will be there.",
            "refused": "I work better at a distance. Close, I am only another target."
          },
          "engage": {
            "accepted": "If the way is clear, I will take the shot.",
            "refused": "No. Noise brings more of them. I will not open that door."
          },
          "withdraw": {
            "accepted": "Yes. I already know three ways out.",
            "refused": "Not yet. The families’ ledge is below us. I do not leave it unwatched."
          }
        },
        "barks": {
          "engage": "Clear line. Loosing.",
          "guard": "Behind you. Quietly.",
          "hold": "Still now. Let them pass.",
          "withdraw": "This way. Soft steps.",
          "defend": "That blade is loud. I heard it coming."
        },
        "returning": {
          "kept": "You walk like the last one. They kept the ledge out of their notes and left the stair alive. I will show you the quiet ways too.",
          "mourned": "The last outsider I guided went down to the kilns and did not come up. I still listen for their step on the ramp.",
          "absent": "Moved the families to a new crossing and has not come back to the bath. Left word: no more outsiders on the water."
        }
      }
    }
  ],
  "seed-alpha": [
    {
      "candidateKey": "displaced-mason-halven-pell",
      "templateId": "displaced-mason",
      "templateTitle": "The Displaced Mason",
      "archetype": "A quarry or public-works worker with militia experience, heavy tools, and a family dependent on wages. Understands structures and refuses to destroy infrastructure people need.",
      "culture": "Veyrathi",
      "name": "Halven Pell",
      "equipment": [
        "item:blade-iron",
        "item:knife-belt",
        "item:gambeson",
        "item:hook-sluicekeeper"
      ],
      "person": {
        "id": "person:companion-displaced-mason-halven-pell",
        "lineageKey": "lineage:displaced-mason-halven-pell",
        "presentationKey": "presentation:actor-outsider-axe-rotation",
        "kinshipKeys": [
          "kinship:displaced-mason-halven-pell-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Halven Pell",
          "origin": "escaped-worker",
          "culture": "Veyrathi",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "quarry-masonry",
            "structural-knowledge"
          ],
          "abilities": [
            "pry-pawl",
            "cleave"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Veyrathi customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-displaced-mason-halven-pell",
        "temperament": {
          "boldness": 8,
          "loyalty": 5
        },
        "obligations": [
          {
            "id": "obligation:displaced-mason-civil-infrastructure-displaced-mason-halven-pell",
            "description": "Support six family dependents in the quarry shanties with bread wages; absolutely refuses to destroy, breach, or flood civil infrastructure that townspeople rely upon for water or shelter.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "Not him, not here. I build things. I will stand like a pier and let him wear himself out."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:displaced-mason-refuse-reckless-charge-displaced-mason-halven-pell",
            "kind": "refuse-goal",
            "goal": "engage"
          }
        ],
        "preferences": {
          "engage": 9,
          "guard": 4,
          "hold": 3,
          "withdraw": 1
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:displaced-mason-displaced-mason-halven-pell",
        "personId": "person:companion-displaced-mason-halven-pell",
        "description": "Earn forty cuts and secure two sacks of flour for the dependents in the lower quarry barracks.",
        "prerequisites": {
          "all": [
            "hired:displaced-mason-halven-pell"
          ],
          "any": [],
          "none": [
            "departed:displaced-mason-halven-pell"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:displaced-mason-displaced-mason-halven-pell",
          "status": "achieved",
          "summary": "Delivered forty cuts and sixty pounds of clean flour to the quarry quarters, securing food through the season.",
          "effects": {
            "add": [
              "obligation-resolved:displaced-mason-halven-pell",
              "loyalty-proven:displaced-mason-halven-pell"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:displaced-mason-displaced-mason-halven-pell",
          "status": "compromised",
          "summary": "Accepted half-pay after refusing to collapse the canal arch, forcing the family onto quarter-rations.",
          "effects": {
            "add": [
              "obligation-compromised:displaced-mason-halven-pell"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:displaced-mason-displaced-mason-halven-pell",
          "status": "abandoned",
          "summary": "Walked away from the party after the player ordered the sluice gates smashed to flood the lower market.",
          "effects": {
            "add": [
              "departed:displaced-mason-halven-pell"
            ],
            "remove": [
              "companion-active:displaced-mason-halven-pell"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-displaced-mason-halven-pell",
          "intention": {
            "kind": "ask",
            "label": "Speak with Halven Pell (The Displaced Mason)"
          },
          "text": "Four children, one chisel, and a lift that stopped because somebody bought a cheap bearing. Hire me and I fix your problems. Ask me to break a wall people sleep behind and I fix you instead.",
          "disclosure": "essential",
          "firstEncounterSummary": "Recruit a muscular stoneworker fighting for family subsistence without compromising civic ethics.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:displaced-mason-halven-pell",
              "rejected:displaced-mason-halven-pell",
              "dead:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "met:displaced-mason-halven-pell"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-displaced-mason-halven-pell",
          "intention": {
            "kind": "offer",
            "label": "Guarantee twelve cuts and swear not to harm civil works"
          },
          "text": "Twelve cuts! The children eat, the stone stands, and you get the best shoulder on the Silt Stair. Everyone wins but the guard.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Halven Pell.",
          "prerequisites": {
            "all": [
              "met:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "hired:displaced-mason-halven-pell",
              "dead:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "hired:displaced-mason-halven-pell",
              "companion-active:displaced-mason-halven-pell"
            ],
            "remove": [
              "available:displaced-mason-halven-pell"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "guarantee:civil-infrastructure"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-displaced-mason-halven-pell",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "Chasing men down corridors is how walls come down on people. I will hold instead.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-halven-pell",
              "departed:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:displaced-mason-halven-pell"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-displaced-mason-halven-pell",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Stand behind me. I am wider than most doors.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-halven-pell",
              "departed:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:displaced-mason-halven-pell"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-displaced-mason-halven-pell",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Agreed. Dead masons build nothing.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-halven-pell",
              "departed:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:displaced-mason-halven-pell"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-displaced-mason-halven-pell",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "See the walkway, under the red mark? A length of timber and a wedge, two cuts, and it holds. Lift that pawl instead and the water takes it, and whoever sleeps behind it.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:displaced-mason-halven-pell"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-displaced-mason-halven-pell",
          "intention": {
            "kind": "leave",
            "label": "Halven Pell departs over contract violation"
          },
          "text": "You lifted the pawl. I told you what was behind that plank. Keep the toll box. I am going to help them bail.",
          "disclosure": "essential",
          "firstEncounterSummary": "Halven Pell leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:displaced-mason-halven-pell",
              "boundary-breached:displaced-mason-halven-pell"
            ],
            "any": [],
            "none": [
              "dead:displaced-mason-halven-pell",
              "departed:displaced-mason-halven-pell"
            ]
          },
          "effects": {
            "add": [
              "departed:displaced-mason-halven-pell"
            ],
            "remove": [
              "companion-active:displaced-mason-halven-pell"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-displaced-mason-halven-pell",
        "name": "Halven Pell",
        "templateId": "displaced-mason",
        "memorialNote": "A heavy leather apron crusted with lime and dried sweat. In the pocket is a copper token stamped with the quarry union mark, worn flat by nervous thumbs.",
        "campNotice": "A pile of chipped cobblestones sits neatly stacked by the bedroll. The mason's place in the meal line is vacant.",
        "witnessReaction": "He braced the cracked lintel with his own shoulders while the rest of us scrambled out. When the stone dropped, he didn't scream."
      },
      "absenceResponse": {
        "companionId": "person:companion-displaced-mason-halven-pell",
        "name": "Halven Pell",
        "templateId": "displaced-mason",
        "reason": "Boundary violated: deliberate destruction of civilian canal infrastructure.",
        "departureLine": "You lifted the pawl. I told you what was behind that plank. Keep the toll box. I am going to help them bail.",
        "campNotice": "A heavy stone mallet laid across an unmortared boundary stone."
      },
      "voice": {
        "voiceId": "mason-pier",
        "care": {
          "offered": "You brought a {item} for the mason? Sensible. Even good stone cracks.",
          "treat": "Something needs patching. Happily, it is still attached.",
          "remember": "{giver} shared medicine when I needed looking after. A sound thing to build a memory on.",
          "aid": "That needs patching before you put weight on it. Sit down; I have what we need.",
          "rememberAid": "I patched {patient} after a fight. More blood than a mason likes to see, but my supplies did their work."
        },
        "manner": "Loud, proud craftsman; stone and building metaphors; jokes; bold.",
        "temperament": {
          "boldness": 8,
          "loyalty": 5
        },
        "obligation": "Wages feed four children in the quarry sheds. Will not break anything people live under.",
        "opening": "Four children, one chisel, and a lift that stopped because somebody bought a cheap bearing. Hire me and I fix your problems. Ask me to break a wall people sleep behind and I fix you instead.",
        "hire": "Twelve cuts! The children eat, the stone stands, and you get the best shoulder on the Silt Stair. Everyone wins but the guard.",
        "hired": "Paid and standing, like a good pier. Point me at something that needs holding up.",
        "refusal": "Not him, not here. I build things. I will stand like a pier and let him wear himself out.",
        "afterFight": {
          "guard": "Down like a bad lintel. Too much weight on one side and nothing underneath. Noll never checked what he was building on.",
          "tunnel": "It was still feeding the kiln. Good worker, poor foreman. Whoever set that task should be carrying the coal themselves."
        },
        "moment": {
          "request": "See the walkway, under the red mark? A length of timber and a wedge, two cuts, and it holds. Lift that pawl instead and the water takes it, and whoever sleeps behind it.",
          "kept": "Two cuts and a wedge! Best repair of the week, and I did not even have to swear at it.",
          "broken": "You lifted the pawl. I told you what was behind that plank. Keep the toll box. I am going to help them bail."
        },
        "judgment": {
          "good": "Grain moving, stone standing, children fed. If every job ended like this I would have to find something new to complain about.",
          "bad": "Burned or sold, it comes to the same: people pay for your hurry. My children cannot eat your excuses. I am off.",
          "depart": "Leaving with the lift half an answer? Go on. I will stay until the escrow opens and the arch is still standing.",
          "mourning": "Four children waiting on me, and you are the one who does not go home. I will set a stone for you. A good one."
        },
        "discuss": {
          "guard": {
            "accepted": "Stand behind me. I am wider than most doors.",
            "refused": "I am better at the wall than at your elbow. Let me brace something."
          },
          "engage": {
            "accepted": "If he runs, I will catch him. I carry stone uphill for a living.",
            "refused": "Chasing men down corridors is how walls come down on people. I will hold instead."
          },
          "withdraw": {
            "accepted": "Agreed. Dead masons build nothing.",
            "refused": "Leave? With that wall ready to go? I am staying where I can keep it up."
          }
        },
        "barks": {
          "engage": "Coming through. Mind the stone.",
          "guard": "Behind me. I am wider.",
          "hold": "Feet set, like a pier.",
          "withdraw": "Back off. This span will not hold.",
          "defend": "Too much weight on one side. I can answer that."
        },
        "returning": {
          "kept": "Another outsider on my stair! The last one who hired me left the walkway standing and walked out alive. Buy me a wedge and we will get on.",
          "mourned": "The outsider before you never came back from the kilns. I set a stone for them by the quarry path. Try not to need another.",
          "absent": "Back at the quarry sheds, bailing out the flooded rooms. Told anyone listening that outsiders pay two cuts and cost a wall."
        }
      }
    },
    {
      "candidateKey": "unpaid-shield-daska-en-or",
      "templateId": "unpaid-shield",
      "templateTitle": "The Unpaid Shield",
      "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
      "culture": "Talruni",
      "name": "Daska En Or",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:knife-belt"
      ],
      "person": {
        "id": "person:companion-unpaid-shield-daska-en-or",
        "lineageKey": "lineage:unpaid-shield-daska-en-or",
        "presentationKey": "presentation:actor-unpaid-shield-rotation",
        "kinshipKeys": [
          "kinship:unpaid-shield-daska-en-or-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Daska En Or",
          "origin": "disgraced-legionary",
          "culture": "Talruni",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "shield-discipline",
            "spear-drill"
          ],
          "abilities": [
            "brace-drill"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Protect the party"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Talruni customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-unpaid-shield-daska-en-or",
        "temperament": {
          "boldness": 3,
          "loyalty": 8
        },
        "obligations": [
          {
            "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-daska-en-or",
            "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "That charge is not in the price. I am not paying my sister’s debt with my own blood."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-daska-en-or",
            "kind": "danger-limit",
            "dangerLimit": 36
          }
        ],
        "preferences": {
          "engage": 4,
          "guard": 9,
          "hold": 6,
          "withdraw": 8
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:unpaid-shield-unpaid-shield-daska-en-or",
        "personId": "person:companion-unpaid-shield-daska-en-or",
        "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
        "prerequisites": {
          "all": [
            "hired:unpaid-shield-daska-en-or"
          ],
          "any": [],
          "none": [
            "departed:unpaid-shield-daska-en-or"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:unpaid-shield-unpaid-shield-daska-en-or",
          "status": "achieved",
          "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
          "effects": {
            "add": [
              "obligation-resolved:unpaid-shield-daska-en-or",
              "loyalty-proven:unpaid-shield-daska-en-or"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:unpaid-shield-unpaid-shield-daska-en-or",
          "status": "compromised",
          "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
          "effects": {
            "add": [
              "obligation-compromised:unpaid-shield-daska-en-or"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:unpaid-shield-unpaid-shield-daska-en-or",
          "status": "abandoned",
          "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
          "effects": {
            "add": [
              "departed:unpaid-shield-daska-en-or"
            ],
            "remove": [
              "companion-active:unpaid-shield-daska-en-or"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "ask",
            "label": "Speak with Daska En Or (The Unpaid Shield)"
          },
          "text": "Eleven cuts and a half. That is what stands between my sister and the end of her bond. I count it every morning. It has not got smaller by itself.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:unpaid-shield-daska-en-or",
              "rejected:unpaid-shield-daska-en-or",
              "dead:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "met:unpaid-shield-daska-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "offer",
            "label": "Agree to twelve-cut wage in escrow"
          },
          "text": "Twelve. Good. The half-cut goes on the next job. I will keep you standing; I will not charge anything that is not in the price.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Daska En Or.",
          "prerequisites": {
            "all": [
              "met:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "hired:unpaid-shield-daska-en-or",
              "dead:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "hired:unpaid-shield-daska-en-or",
              "companion-active:unpaid-shield-daska-en-or"
            ],
            "remove": [
              "available:unpaid-shield-daska-en-or"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "escrow:guaranteed-wage"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "A chase is not in the price. My sister’s bond does not get shorter because I ran after somebody.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-daska-en-or",
              "departed:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:unpaid-shield-daska-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "Close. Two paces, left side. Call out if you are hit; I cannot count wounds I cannot see.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-daska-en-or",
              "departed:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:unpaid-shield-daska-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Agreed. A living guard earns more than a dead one. I have done that sum as well.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-daska-en-or",
              "departed:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:unpaid-shield-daska-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "While you are at the desk, ask about the second toll on the stair. Four cuts a crossing, twice. I have the figures for the porters, if the clerk wants them.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:unpaid-shield-daska-en-or"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-unpaid-shield-daska-en-or",
          "intention": {
            "kind": "leave",
            "label": "Daska En Or departs over contract violation"
          },
          "text": "Four cuts from the porters’ bowl. I know exactly what four cuts buys. Pay me out; I am finished counting for you.",
          "disclosure": "essential",
          "firstEncounterSummary": "Daska En Or leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-daska-en-or",
              "boundary-breached:unpaid-shield-daska-en-or"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-daska-en-or",
              "departed:unpaid-shield-daska-en-or"
            ]
          },
          "effects": {
            "add": [
              "departed:unpaid-shield-daska-en-or"
            ],
            "remove": [
              "companion-active:unpaid-shield-daska-en-or"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-unpaid-shield-daska-en-or",
        "name": "Daska En Or",
        "templateId": "unpaid-shield",
        "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
        "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
        "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
      },
      "absenceResponse": {
        "companionId": "person:companion-unpaid-shield-daska-en-or",
        "name": "Daska En Or",
        "templateId": "unpaid-shield",
        "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
        "departureLine": "Four cuts from the porters’ bowl. I know exactly what four cuts buys. Pay me out; I am finished counting for you.",
        "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
      },
      "voice": {
        "voiceId": "shield-tally",
        "care": {
          "offered": "One {item}. I will count it among the things that get us home.",
          "treat": "Hold your ground. I need one moment for this wound.",
          "remember": "{giver} gave me supplies out of their own pack. That debt is on my tally.",
          "aid": "One wound still open. Yours. Sit down; I have supplies for it.",
          "rememberAid": "I used my supplies on {patient} after a fight. Two people still standing was the better tally."
        },
        "manner": "Counts everything aloud; dry; fond of her sister; cautious, stays close.",
        "temperament": {
          "boldness": 3,
          "loyalty": 8
        },
        "obligation": "Wages paid straight to the depot clerk, against a sister’s bond. No unpaid assaults.",
        "opening": "Eleven cuts and a half. That is what stands between my sister and the end of her bond. I count it every morning. It has not got smaller by itself.",
        "hire": "Twelve. Good. The half-cut goes on the next job. I will keep you standing; I will not charge anything that is not in the price.",
        "hired": "Twelve paid, eleven and a half still owed on my sister. I stay close. Tell me where we are going and I will count the steps.",
        "refusal": "That charge is not in the price. I am not paying my sister’s debt with my own blood.",
        "afterFight": {
          "guard": "One guard, one doorway. I counted his breaths before he drew: eleven, then nothing. Are you hurt, or only shaking?",
          "tunnel": "It kept stoking until it could not. Somebody set it that task and never came back to count the cost."
        },
        "moment": {
          "request": "While you are at the desk, ask about the second toll on the stair. Four cuts a crossing, twice. I have the figures for the porters, if the clerk wants them.",
          "kept": "Struck from the schedule. Four cuts a crossing the porters keep. I will add that up again tonight, just to hear the sum.",
          "broken": "Four cuts from the porters’ bowl. I know exactly what four cuts buys. Pay me out; I am finished counting for you."
        },
        "judgment": {
          "good": "Paid in full, to the clerk, stamped. My sister walks out of the depot on her own feet. I will not forget whose cuts they were.",
          "bad": "You kept the kilns working for a repair fund. There is no column in any ledger for that. I am going.",
          "depart": "You are leaving before the account is closed. I am not. Somebody has to be here when the clerk opens.",
          "mourning": "Twelve cuts in escrow, and one outsider on the floor. The clerk will pay the first. I will make sure someone hears about the second."
        },
        "discuss": {
          "guard": {
            "accepted": "Close. Two paces, left side. Call out if you are hit; I cannot count wounds I cannot see.",
            "refused": "I stay where the shield does some good. That is not always beside you."
          },
          "engage": {
            "accepted": "If he gives ground and the ground is paid for, yes.",
            "refused": "A chase is not in the price. My sister’s bond does not get shorter because I ran after somebody."
          },
          "withdraw": {
            "accepted": "Agreed. A living guard earns more than a dead one. I have done that sum as well.",
            "refused": "I leave when the contract ends, not when it gets frightening. Otherwise the numbers mean nothing."
          }
        },
        "barks": {
          "engage": "He is open. Taking it.",
          "guard": "On your left. Two paces.",
          "hold": "Holding. Let them come to the rim.",
          "withdraw": "Too many. Stepping back to count.",
          "defend": "Too much weight in that swing. I mean to get home."
        },
        "returning": {
          "kept": "You came down the same stair as the last outsider who hired me. That one paid to the cut and walked out alive. I remember both. Do you mean to match them?",
          "mourned": "The outsider before you died on the kiln ramp. The escrow still paid; I still counted it. Tell me you plan better.",
          "absent": "Took paid work at the depot instead. Told Melian that clerks at least write down what they take."
        }
      }
    },
    {
      "candidateKey": "towpath-scout-arel-vall",
      "templateId": "towpath-scout",
      "templateTitle": "The Towpath Scout",
      "archetype": "A ferry worker or canal guide selling local knowledge after losing regular work. Notices routes, uses a bow or javelins, values discretion, and refuses to expose escape routes used by vulnerable people.",
      "culture": "Orsene",
      "name": "Arel Vall",
      "equipment": [
        "item:bow-ash",
        "item:knife-belt",
        "item:satchel",
        "item:field-dressing"
      ],
      "person": {
        "id": "person:companion-towpath-scout-arel-vall",
        "lineageKey": "lineage:towpath-scout-arel-vall",
        "presentationKey": "presentation:actor-towpath-scout-rotation",
        "kinshipKeys": [
          "kinship:towpath-scout-arel-vall-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Arel Vall",
          "origin": "escaped-worker",
          "culture": "Orsene",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "towpath-recon",
            "skirmish-archery"
          ],
          "abilities": [
            "loose-arrow",
            "quick-cut"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 8,
          "maxHp": 8,
          "allegiances": [],
          "oaths": [
            "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Orsene customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-towpath-scout-arel-vall",
        "temperament": {
          "boldness": 1,
          "loyalty": 5
        },
        "obligations": [
          {
            "id": "obligation:towpath-scout-towpath-escape-routes-towpath-scout-arel-vall",
            "description": "Shield the hidden towpath cuts and weir crawls used by destitute runaways; refuses any action or disclosure that exposes these paths to the canal bailiffs.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "I cannot. If they see my face they will know where I came from. I am staying back."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:towpath-scout-danger-limit-towpath-scout-arel-vall",
            "kind": "danger-limit",
            "dangerLimit": 26
          }
        ],
        "preferences": {
          "engage": 1,
          "guard": 6,
          "hold": 9,
          "withdraw": 10
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:towpath-scout-towpath-scout-arel-vall",
        "personId": "person:companion-towpath-scout-arel-vall",
        "description": "Guide four fugitive families past the toll chain without exposing the hidden culvert to the bailiffs.",
        "prerequisites": {
          "all": [
            "hired:towpath-scout-arel-vall"
          ],
          "any": [],
          "none": [
            "departed:towpath-scout-arel-vall"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:towpath-scout-towpath-scout-arel-vall",
          "status": "achieved",
          "summary": "Guided four families past the toll chain under cover of morning silt fog without alerting the watch.",
          "effects": {
            "add": [
              "obligation-resolved:towpath-scout-arel-vall",
              "loyalty-proven:towpath-scout-arel-vall"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:towpath-scout-towpath-scout-arel-vall",
          "status": "compromised",
          "summary": "Traded an obsolete bypass route to the customs inspector to divert attention from the active cut.",
          "effects": {
            "add": [
              "obligation-compromised:towpath-scout-arel-vall"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:towpath-scout-towpath-scout-arel-vall",
          "status": "abandoned",
          "summary": "Fled into the reeds after the player attempted to sell the towpath map to the basin toll collector.",
          "effects": {
            "add": [
              "departed:towpath-scout-arel-vall"
            ],
            "remove": [
              "companion-active:towpath-scout-arel-vall"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-towpath-scout-arel-vall",
          "intention": {
            "kind": "ask",
            "label": "Speak with Arel Vall (The Towpath Scout)"
          },
          "text": "I came up through that drain myself, three winters ago. I know every step of it in the dark. I will guide you. I will not be seen doing it.",
          "disclosure": "essential",
          "firstEncounterSummary": "Engage a quiet canal guide who knows unseen routes through the flooded terraces.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:towpath-scout-arel-vall",
              "rejected:towpath-scout-arel-vall",
              "dead:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "met:towpath-scout-arel-vall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-towpath-scout-arel-vall",
          "intention": {
            "kind": "offer",
            "label": "Pledge secrecy regarding escape culverts and pay ten cuts"
          },
          "text": "All right. Twelve cuts. I stay behind you, and if the bailiffs come, I was never here.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Arel Vall.",
          "prerequisites": {
            "all": [
              "met:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "hired:towpath-scout-arel-vall",
              "dead:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "hired:towpath-scout-arel-vall",
              "companion-active:towpath-scout-arel-vall"
            ],
            "remove": [
              "available:towpath-scout-arel-vall"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "silence:escape-routes"
          ],
          "socialDifficulty": 2
        },
        {
          "id": "dialogue:approach-engage-towpath-scout-arel-vall",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No. I do not chase people. People chased me.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-arel-vall",
              "departed:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:towpath-scout-arel-vall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-towpath-scout-arel-vall",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I will try. I will be close. I might shake.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-arel-vall",
              "departed:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:towpath-scout-arel-vall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-towpath-scout-arel-vall",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Yes. Yes, please. I know where.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-arel-vall",
              "departed:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:towpath-scout-arel-vall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-towpath-scout-arel-vall",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "Please. The shoes on the ledge. Do not put it in the report. I was one of those shoes.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:towpath-scout-arel-vall"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-towpath-scout-arel-vall",
          "intention": {
            "kind": "leave",
            "label": "Arel Vall departs over contract violation"
          },
          "text": "You told them. You told them about the ledge. I have to go and warn them. Do not follow me.",
          "disclosure": "essential",
          "firstEncounterSummary": "Arel Vall leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:towpath-scout-arel-vall",
              "boundary-breached:towpath-scout-arel-vall"
            ],
            "any": [],
            "none": [
              "dead:towpath-scout-arel-vall",
              "departed:towpath-scout-arel-vall"
            ]
          },
          "effects": {
            "add": [
              "departed:towpath-scout-arel-vall"
            ],
            "remove": [
              "companion-active:towpath-scout-arel-vall"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-towpath-scout-arel-vall",
        "name": "Arel Vall",
        "templateId": "towpath-scout",
        "memorialNote": "An ash bow with a worn cord, wrapped in greased oilcloth. Inside the quiver is a charcoal map of water depths, unmarked by any official seal.",
        "campNotice": "A bundle of willow cord hangs by the cold brazier. The scout didn't return from the evening canal watch.",
        "witnessReaction": "She slipped through thirty patrols without a ripple. It took a blind crossbow in the fog to stop her."
      },
      "absenceResponse": {
        "companionId": "person:companion-towpath-scout-arel-vall",
        "name": "Arel Vall",
        "templateId": "towpath-scout",
        "reason": "Boundary violated: secret towpath escape route betrayed to canal guards.",
        "departureLine": "You told them. You told them about the ledge. I have to go and warn them. Do not follow me.",
        "campNotice": "A footprint in wet clay near the canal edge, leading into the deep reed bed."
      },
      "voice": {
        "voiceId": "scout-drain",
        "care": {
          "offered": "I can carry the {item}. Thank you. I know when to stop and use it.",
          "treat": "I found room. Let me stop this bleeding.",
          "remember": "{giver} gave me supplies for my wounds. Nobody asked me to earn them back.",
          "aid": "You are hurt. I can help now. Please, sit still.",
          "rememberAid": "{patient} needed help after the fight. I had something to give. I remember that."
        },
        "manner": "Nervous former runaway; short sentences; frank; timid in a fight but fiercely protective.",
        "temperament": {
          "boldness": 1,
          "loyalty": 5
        },
        "obligation": "Came up through the drain as a runaway. Guards the path for those still running; will not be seen by bailiffs.",
        "opening": "I came up through that drain myself, three winters ago. I know every step of it in the dark. I will guide you. I will not be seen doing it.",
        "hire": "All right. Twelve cuts. I stay behind you, and if the bailiffs come, I was never here.",
        "hired": "I am here. Behind you. Keep off the main stair if you can.",
        "refusal": "I cannot. If they see my face they will know where I came from. I am staying back.",
        "afterFight": {
          "guard": "I closed my eyes. I heard it, though. Is it over? It is over.",
          "tunnel": "It might have been someone from the drain. Some of us never got out. I keep thinking that."
        },
        "moment": {
          "request": "Please. The shoes on the ledge. Do not put it in the report. I was one of those shoes.",
          "kept": "Thank you. They will never know it was you. That is how it is supposed to work.",
          "broken": "You told them. You told them about the ledge. I have to go and warn them. Do not follow me."
        },
        "judgment": {
          "good": "Paid, and the ledge still hidden. I did not think outsiders did both. I am glad I was wrong.",
          "bad": "You kept it all running. You are no better than the people I ran from. I am going.",
          "depart": "You are leaving? I am not. This is the only place I know how to hide.",
          "mourning": "I hid while you died. I always hide. I will take your name down the drain and say it where it is safe."
        },
        "discuss": {
          "guard": {
            "accepted": "I will try. I will be close. I might shake.",
            "refused": "I cannot be seen next to you. Please do not ask that."
          },
          "engage": {
            "accepted": "If he is running away, maybe. Running is different.",
            "refused": "No. I do not chase people. People chased me."
          },
          "withdraw": {
            "accepted": "Yes. Yes, please. I know where.",
            "refused": "Not without the others. I left people once already."
          }
        },
        "barks": {
          "engage": "Now, while he is turned.",
          "guard": "Here. Right behind you.",
          "hold": "Stay down. Do not move.",
          "withdraw": "Out. Through here, quickly.",
          "defend": "I saw the shoulder turn. Not this time."
        },
        "returning": {
          "kept": "You are not the last one, are you? The last outsider kept the ledge secret and got away. I still owe them for that.",
          "mourned": "The outsider I guided before you died at the kilns. I hid. I am trying not to hide this time.",
          "absent": "Went back down the drain and has not come up. Left a note under the bath step: outsiders tell."
        }
      }
    }
  ],
  "seed-beta": [
    {
      "candidateKey": "former-mortuary-guard-jessa-menn",
      "templateId": "former-mortuary-guard",
      "templateTitle": "The Former Mortuary Guard",
      "archetype": "A funerary escort who left the concession after a disturbing incident in the Quiet Kilns. Uses a shield and short spear, recognises burial practices, and refuses corpse desecration.",
      "culture": "Orsene",
      "name": "Jessa Menn",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:oil-flask"
      ],
      "person": {
        "id": "person:companion-former-mortuary-guard-jessa-menn",
        "lineageKey": "lineage:former-mortuary-guard-jessa-menn",
        "presentationKey": "presentation:actor-mortuary-guard-rotation",
        "kinshipKeys": [
          "kinship:former-mortuary-guard-jessa-menn-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Jessa Menn",
          "origin": "disgraced-legionary",
          "culture": "Orsene",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "funerary-vigil",
            "spear-drill"
          ],
          "abilities": [
            "thrust",
            "set-spear"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 9,
          "maxHp": 9,
          "allegiances": [],
          "oaths": [
            "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Seize the initiative",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Orsene customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-former-mortuary-guard-jessa-menn",
        "temperament": {
          "boldness": 9,
          "loyalty": 3
        },
        "obligations": [
          {
            "id": "obligation:former-mortuary-guard-burial-sanctity-former-mortuary-guard-jessa-menn",
            "description": "Uphold ancient funerary dignity and prevent mutilation or enslavement of remains; strictly refuses to permit corpse desecration and demands tangible evidence before trusting any ritual binder.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "I do not stab the dead. Rude, pointless, and they never stay down anyway. Go round."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:former-mortuary-guard-danger-limit-former-mortuary-guard-jessa-menn",
            "kind": "danger-limit",
            "dangerLimit": 34
          }
        ],
        "preferences": {
          "engage": 9,
          "guard": 3,
          "hold": 0,
          "withdraw": 1
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
        "personId": "person:companion-former-mortuary-guard-jessa-menn",
        "description": "Recover stolen corpse records and secure honest burial in salted earth for the desecrated kiln remains.",
        "prerequisites": {
          "all": [
            "hired:former-mortuary-guard-jessa-menn"
          ],
          "any": [],
          "none": [
            "departed:former-mortuary-guard-jessa-menn"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
          "status": "achieved",
          "summary": "Recovered three stolen corpses from the cooling gallery and saw them properly interred in salted earth.",
          "effects": {
            "add": [
              "obligation-resolved:former-mortuary-guard-jessa-menn",
              "loyalty-proven:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
          "status": "compromised",
          "summary": "Allowed an unverified binder to perform a diagnostic inspection only under direct, armed supervision.",
          "effects": {
            "add": [
              "obligation-compromised:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:former-mortuary-guard-former-mortuary-guard-jessa-menn",
          "status": "abandoned",
          "summary": "Severed ties after the player attempted to harvest limbs or bones for necromantic reagents.",
          "effects": {
            "add": [
              "departed:former-mortuary-guard-jessa-menn"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-jessa-menn"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "ask",
            "label": "Speak with Jessa Menn (The Former Mortuary Guard)"
          },
          "text": "Burial escort, retired, badly. I have guarded the dead from grave robbers, family, priests and once a goat. Somebody down in the kilns is worse than the goat. I would like to meet them.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire a grim former necropolis watchman who demands strict reverence for the dead and physical proof of claims.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-jessa-menn",
              "rejected:former-mortuary-guard-jessa-menn",
              "dead:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "met:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "offer",
            "label": "Pledge reverence to the mortuary vaults and pay fourteen cuts"
          },
          "text": "Twelve cuts and I am yours until the dead are sorted. I fight hard, talk too much and never touch a body without asking it first.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Jessa Menn.",
          "prerequisites": {
            "all": [
              "met:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "hired:former-mortuary-guard-jessa-menn",
              "dead:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "hired:former-mortuary-guard-jessa-menn",
              "companion-active:former-mortuary-guard-jessa-menn"
            ],
            "remove": [
              "available:former-mortuary-guard-jessa-menn"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "covenant:no-desecration"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "Not among the stations. Dead folk underfoot. I will not dance on them.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-jessa-menn",
              "departed:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I fight better loose. Stand where you like; I will be where it is loud.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-jessa-menn",
              "departed:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Retreat? Now you are talking my language. The living one, I mean.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-jessa-menn",
              "departed:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "You have the pattern. Take the anchor off him. Gently, mind; he has done enough work for three men.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:former-mortuary-guard-jessa-menn"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-former-mortuary-guard-jessa-menn",
          "intention": {
            "kind": "leave",
            "label": "Jessa Menn departs over contract violation"
          },
          "text": "More wax. So the dead get another shift. I have a limit, and it is right there. I am off.",
          "disclosure": "essential",
          "firstEncounterSummary": "Jessa Menn leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:former-mortuary-guard-jessa-menn",
              "boundary-breached:former-mortuary-guard-jessa-menn"
            ],
            "any": [],
            "none": [
              "dead:former-mortuary-guard-jessa-menn",
              "departed:former-mortuary-guard-jessa-menn"
            ]
          },
          "effects": {
            "add": [
              "departed:former-mortuary-guard-jessa-menn"
            ],
            "remove": [
              "companion-active:former-mortuary-guard-jessa-menn"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-former-mortuary-guard-jessa-menn",
        "name": "Jessa Menn",
        "templateId": "former-mortuary-guard",
        "memorialNote": "A bronze shield bearing the faint silhouette of a laurel wreath, tarnished by tomb smoke. Beside it sits a small clay flask of holding salt and an unlit bronze lamp.",
        "campNotice": "The guard's spear is driven upright into the loam. A small pinch of salt has been scattered across the mound.",
        "witnessReaction": "She stood between the animated corpses and the altar until her spear snapped. She died keeping the threshold clean."
      },
      "absenceResponse": {
        "companionId": "person:companion-former-mortuary-guard-jessa-menn",
        "name": "Jessa Menn",
        "templateId": "former-mortuary-guard",
        "reason": "Boundary violated: desecration of burial remains or unproven necromantic practice.",
        "departureLine": "More wax. So the dead get another shift. I have a limit, and it is right there. I am off.",
        "campNotice": "A consecrated funeral tile left standing at the entrance to the abandoned gallery."
      },
      "voice": {
        "voiceId": "guard-gallows",
        "care": {
          "offered": "A {item}. Lovely. I prefer my wages without a funeral deduction.",
          "treat": "Still breathing. Planning to keep the habit.",
          "remember": "{giver} shared their supplies. Very inconsiderate of them; now I have to remember someone fondly.",
          "aid": "Sit down. You are making a poor case for keeping your blood. I can help with that.",
          "rememberAid": "I dressed {patient}’s wounds. They were very inconsiderate wounds. Used up my medicine."
        },
        "manner": "Old hand with gallows humour; blunt; never jokes about the dead themselves; bold, independent.",
        "temperament": {
          "boldness": 9,
          "loyalty": 3
        },
        "obligation": "An old hand of the burial escort. Protects the dead from the living, for a fee.",
        "opening": "Burial escort, retired, badly. I have guarded the dead from grave robbers, family, priests and once a goat. Somebody down in the kilns is worse than the goat. I would like to meet them.",
        "hire": "Twelve cuts and I am yours until the dead are sorted. I fight hard, talk too much and never touch a body without asking it first.",
        "hired": "Still hired, still breathing, still no goats. Where next?",
        "refusal": "I do not stab the dead. Rude, pointless, and they never stay down anyway. Go round.",
        "afterFight": {
          "guard": "There. He is dead and we are not. That is the whole of my trade, really. Someone will want the boots.",
          "tunnel": "Poor devil kept stoking with half its ribs gone. Better worker than most of the living. Let us see it gets paid in rest."
        },
        "moment": {
          "request": "You have the pattern. Take the anchor off him. Gently, mind; he has done enough work for three men.",
          "kept": "Down he goes, polite as you like. That is how the dead ought to leave. Nobody shouting.",
          "broken": "More wax. So the dead get another shift. I have a limit, and it is right there. I am off."
        },
        "judgment": {
          "good": "Nine names, nine bodies, one very tired escort. I have had worse jobs. I have been paid worse, too.",
          "bad": "You let the dead keep working, or you burned them faceless. I do not joke about that. I am going.",
          "depart": "Off you go. I will stay for the carrying. Somebody has to make sure nobody steals the coffins twice.",
          "mourning": "Well. I have escorted a lot of people to their graves. I did not plan to start on my employer. I will walk you there properly."
        },
        "discuss": {
          "guard": {
            "accepted": "I will stay close. Try not to die; it makes the paperwork dreadful.",
            "refused": "I fight better loose. Stand where you like; I will be where it is loud."
          },
          "engage": {
            "accepted": "If he gives ground, I take it, and whatever he is holding.",
            "refused": "Not among the stations. Dead folk underfoot. I will not dance on them."
          },
          "withdraw": {
            "accepted": "Retreat? Now you are talking my language. The living one, I mean.",
            "refused": "I go when I go. Nobody has buried me yet and you are not starting."
          }
        },
        "barks": {
          "engage": "Here we go, then!",
          "guard": "Stay behind the old dog.",
          "hold": "Nobody move. Dead folk underfoot.",
          "withdraw": "Back up. Not ready to be buried.",
          "defend": "A generous swing. Far too generous."
        },
        "returning": {
          "kept": "Ha! Another outsider. The last one hired me, sorted the dead and walked out breathing. Rare. Let us try for twice.",
          "mourned": "The outsider before you, I walked to the grave myself. Did it properly, too. I would rather not get the practice.",
          "absent": "Took a job guarding a cemetery upriver. Said the dead there at least stay where you put them, and outsiders do not."
        }
      }
    },
    {
      "candidateKey": "unpaid-shield-velka-en-taren",
      "templateId": "unpaid-shield",
      "templateTitle": "The Unpaid Shield",
      "archetype": "A former professional infantry soldier seeking the release of a dependent from a service debt. Usually protects exposed allies, dislikes unnecessary chases, and refuses unpaid military duties.",
      "culture": "Talruni",
      "name": "Velka En Taren",
      "equipment": [
        "item:shield-round",
        "item:spear-bronze",
        "item:gambeson",
        "item:knife-belt"
      ],
      "person": {
        "id": "person:companion-unpaid-shield-velka-en-taren",
        "lineageKey": "lineage:unpaid-shield-velka-en-taren",
        "presentationKey": "presentation:actor-unpaid-shield-rotation",
        "kinshipKeys": [
          "kinship:unpaid-shield-velka-en-taren-dependent"
        ],
        "lifecycle": "active",
        "location": "Z03",
        "current": {
          "name": "Velka En Taren",
          "origin": "disgraced-legionary",
          "culture": "Talruni",
          "originalRunId": "run:1",
          "latestRunId": "run:1",
          "equipment": [],
          "inventory": [],
          "skills": [
            "shield-discipline",
            "spear-drill"
          ],
          "abilities": [
            "brace-drill"
          ],
          "preparedRites": [],
          "reagents": [],
          "hp": 10,
          "maxHp": 10,
          "allegiances": [],
          "oaths": [
            "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond."
          ],
          "reputation": [],
          "personalOutcome": "Unresolved",
          "relationships": [
            {
              "personId": "person:pc",
              "fact": "prospective-hireling"
            }
          ],
          "deeds": [],
          "values": [
            "Conserve strength",
            "Preserve independence"
          ],
          "memories": [
            "Arrived at Silt Stair seeking work under Talruni customs."
          ],
          "evidence": []
        },
        "original": null,
        "deathEventId": null
      },
      "contract": {
        "companionId": "person:companion-unpaid-shield-velka-en-taren",
        "temperament": {
          "boldness": 2,
          "loyalty": 2
        },
        "obligations": [
          {
            "id": "obligation:unpaid-shield-dependent-debt-unpaid-shield-velka-en-taren",
            "description": "Discharge a dependent sister's labour bond held by the concession depot; refuses unpaid assaults, military duties, or bloodbaths that yield no payment towards the bond.",
            "forbiddenGoals": [
              "engage"
            ],
            "refusal": "Not that one. Not for this pay."
          }
        ],
        "boundaries": [
          {
            "id": "boundary:unpaid-shield-danger-limit-unpaid-shield-velka-en-taren",
            "kind": "danger-limit",
            "dangerLimit": 36
          }
        ],
        "preferences": {
          "engage": 2,
          "guard": 1,
          "hold": 9,
          "withdraw": 9
        },
        "refusals": [],
        "discussionSequence": 0
      },
      "personalGoal": {
        "id": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
        "personId": "person:companion-unpaid-shield-velka-en-taren",
        "description": "Secure 24 cuts to discharge the sister's labour bond from the concession registry.",
        "prerequisites": {
          "all": [
            "hired:unpaid-shield-velka-en-taren"
          ],
          "any": [],
          "none": [
            "departed:unpaid-shield-velka-en-taren"
          ]
        }
      },
      "personalGoalOutcomes": {
        "achieved": {
          "goalId": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
          "status": "achieved",
          "summary": "Paid 24 cuts directly to the concession clerk, securing the stamped deed of release for his sister.",
          "effects": {
            "add": [
              "obligation-resolved:unpaid-shield-velka-en-taren",
              "loyalty-proven:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          }
        },
        "compromised": {
          "goalId": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
          "status": "compromised",
          "summary": "Negotiated a half-term deferral with the Reeve in exchange for testimony against the concession bookkeeper.",
          "effects": {
            "add": [
              "obligation-compromised:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          }
        },
        "abandoned": {
          "goalId": "goal:unpaid-shield-unpaid-shield-velka-en-taren",
          "status": "abandoned",
          "summary": "Departed after the employer repeatedly refused to allocate contract shares towards the bond.",
          "effects": {
            "add": [
              "departed:unpaid-shield-velka-en-taren"
            ],
            "remove": [
              "companion-active:unpaid-shield-velka-en-taren"
            ]
          }
        }
      },
      "dialogueOptions": [
        {
          "id": "dialogue:intro-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "ask",
            "label": "Speak with Velka En Taren (The Unpaid Shield)"
          },
          "text": "Daughter’s bonded. I guard. You pay. That is all of it.",
          "disclosure": "essential",
          "firstEncounterSummary": "Hire an experienced shieldman working to clear a family labour debt.",
          "prerequisites": {
            "all": [],
            "any": [],
            "none": [
              "hired:unpaid-shield-velka-en-taren",
              "rejected:unpaid-shield-velka-en-taren",
              "dead:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "met:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:contract-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "offer",
            "label": "Agree to twelve-cut wage in escrow"
          },
          "text": "Coin first. Then I walk behind you.",
          "disclosure": "essential",
          "firstEncounterSummary": "Agree to hiring terms and milestone pay with Velka En Taren.",
          "prerequisites": {
            "all": [
              "met:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "hired:unpaid-shield-velka-en-taren",
              "dead:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "hired:unpaid-shield-velka-en-taren",
              "companion-active:unpaid-shield-velka-en-taren"
            ],
            "remove": [
              "available:unpaid-shield-velka-en-taren"
            ]
          },
          "requiredIncentives": [
            "payment:advance-cuts"
          ],
          "requiredProtections": [
            "escrow:guaranteed-wage"
          ],
          "socialDifficulty": 3
        },
        {
          "id": "dialogue:approach-engage-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "promise",
            "label": "Propose aggressive engagement"
          },
          "text": "No chasing. Not paid for it.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-velka-en-taren",
              "departed:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "discussed:engage:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-guard-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "promise",
            "label": "Propose guarded positioning"
          },
          "text": "I keep my own distance.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-velka-en-taren",
              "departed:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "discussed:guard:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:approach-withdraw-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "promise",
            "label": "Propose measured withdrawal"
          },
          "text": "Yes. Always.",
          "disclosure": "supporting",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-velka-en-taren",
              "departed:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "discussed:withdraw:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:boundary-warn-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "warn",
            "label": "Acknowledge boundary terms"
          },
          "text": "Court. Second toll on the stair. Get it struck.",
          "disclosure": "deep",
          "firstEncounterSummary": null,
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "boundary-acknowledged:unpaid-shield-velka-en-taren"
            ],
            "remove": []
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        },
        {
          "id": "dialogue:departure-unpaid-shield-velka-en-taren",
          "intention": {
            "kind": "leave",
            "label": "Velka En Taren departs over contract violation"
          },
          "text": "Porters’ bowl. No. Pay me out.",
          "disclosure": "essential",
          "firstEncounterSummary": "Velka En Taren leaves the party after a non-negotiable boundary was violated.",
          "prerequisites": {
            "all": [
              "hired:unpaid-shield-velka-en-taren",
              "boundary-breached:unpaid-shield-velka-en-taren"
            ],
            "any": [],
            "none": [
              "dead:unpaid-shield-velka-en-taren",
              "departed:unpaid-shield-velka-en-taren"
            ]
          },
          "effects": {
            "add": [
              "departed:unpaid-shield-velka-en-taren"
            ],
            "remove": [
              "companion-active:unpaid-shield-velka-en-taren"
            ]
          },
          "requiredIncentives": [],
          "requiredProtections": [],
          "socialDifficulty": null
        }
      ],
      "deathResponse": {
        "companionId": "person:companion-unpaid-shield-velka-en-taren",
        "name": "Velka En Taren",
        "templateId": "unpaid-shield",
        "memorialNote": "The shield is dented along the rim, bearing seven tally cuts. In the tunic is an unsubmitted receipt for eighteen cuts addressed to the Silt Stair labour depot.",
        "campNotice": "The shield stands upright by the tent flap, but no one has checked the strap rivets since dusk.",
        "witnessReaction": "He took two spear points that were meant for the outsider. He never asked whether the coin was real."
      },
      "absenceResponse": {
        "companionId": "person:companion-unpaid-shield-velka-en-taren",
        "name": "Velka En Taren",
        "templateId": "unpaid-shield",
        "reason": "Contract breached: unpaid military charges demanded without bond compensation.",
        "departureLine": "Porters’ bowl. No. Pay me out.",
        "campNotice": "An empty pallet and a neatly stacked pile of ration tins marked 'returned'."
      },
      "voice": {
        "voiceId": "shield-silent",
        "care": {
          "offered": "The {item} is welcome. I choose the moment.",
          "treat": "Need room. This wound first.",
          "remember": "{giver} spared supplies. I remember that.",
          "aid": "Sit. Your wound needs this more than mine.",
          "rememberAid": "I bound {patient}’s wound. My supplies. My choice."
        },
        "manner": "Very few words; fatalist; trusts coin, not people; cautious and independent.",
        "temperament": {
          "boldness": 2,
          "loyalty": 2
        },
        "obligation": "Paid by the hour, against a daughter’s bond. Stays out of charges.",
        "opening": "Daughter’s bonded. I guard. You pay. That is all of it.",
        "hire": "Coin first. Then I walk behind you.",
        "hired": "Paid. Here. Go on.",
        "refusal": "Not that one. Not for this pay.",
        "afterFight": {
          "guard": "He is dead. You are not. Count that and move.",
          "tunnel": "It did not know it was dead. Lucky."
        },
        "moment": {
          "request": "Court. Second toll on the stair. Get it struck.",
          "kept": "Struck. Good.",
          "broken": "Porters’ bowl. No. Pay me out."
        },
        "judgment": {
          "good": "Paid. Daughter’s bond is shorter. Thank you.",
          "bad": "You kept it running for a repair fund. I am done.",
          "depart": "You go. I stay till the escrow opens.",
          "mourning": "Shame. You paid on time."
        },
        "discuss": {
          "guard": {
            "accepted": "Close. Fine.",
            "refused": "I keep my own distance."
          },
          "engage": {
            "accepted": "If it is safe.",
            "refused": "No chasing. Not paid for it."
          },
          "withdraw": {
            "accepted": "Yes. Always.",
            "refused": "I choose when I go."
          }
        },
        "barks": {
          "engage": "Now.",
          "guard": "Behind me.",
          "hold": "Holding.",
          "withdraw": "Going. Follow or don’t.",
          "defend": "Saw it. Ready."
        },
        "returning": {
          "kept": "Worked for the last outsider. Paid on time. Lived. You?",
          "mourned": "Last outsider died at the kilns. Paid on time, though.",
          "absent": "Gone. Said the last outsider cost more than they paid."
        }
      }
    }
  ]
}
